<template>
  <BRow>
    <BCol xl="12">
      <BCard no-body class="ticket-wizard border-0 shadow-sm">
        <BCardBody class="p-4 p-lg-5">
          <form @submit.prevent>
            <div class="wizard-header">
              <h4 class="mb-1">Abrir chamado</h4>
              <p class="text-muted mb-0">Preencha os dados em 3 etapas para iniciar seu atendimento.</p>
            </div>

            <div id="custom-progress-bar" class="progress-nav mb-4">
              <div class="wizard-progress-meta">
                <span>Etapa {{ activeTab }} de 3</span>
                <span>{{ progressbarvalue }}%</span>
              </div>
              <div class="progress wizard-progress">
                <div
                  class="progress-bar"
                  role="progressbar"
                  :style="`width: ${progressbarvalue}%;`"
                  aria-valuenow="0"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>

              <ul class="nav nav-pills progress-bar-tab custom-nav wizard-steps" role="tablist">
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="pills-gen-info-tab"
                    type="button"
                    role="tab"
                    :class="{ active: activeTab == 1, done: activeTab > 1 }"
                  >
                    <span class="wizard-step-index">1</span>
                    <span class="wizard-step-meta">
                      <span class="wizard-step-title">Dados iniciais</span>
                      <small>Categoria e localidade</small>
                    </span>
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="pills-info-desc-tab"
                    type="button"
                    role="tab"
                    :class="{ active: activeTab == 2, done: activeTab > 2 }"
                  >
                    <span class="wizard-step-index">2</span>
                    <span class="wizard-step-meta">
                      <span class="wizard-step-title">Detalhes</span>
                      <small>Descrição do problema</small>
                    </span>
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="pills-success-tab"
                    type="button"
                    role="tab"
                    :class="{ active: activeTab == 3, done: activeTab > 3 }"
                  >
                    <span class="wizard-step-index">3</span>
                    <span class="wizard-step-meta">
                      <span class="wizard-step-title">Concluído</span>
                      <small>Solicitação registrada</small>
                    </span>
                  </button>
                </li>
              </ul>
            </div>

            <div class="tab-content">
              <div
                class="tab-pane fade step-pane"
                :class="activeTab == 1 && 'show active'"
                id="pills-gen-info"
                role="tabpanel"
                aria-labelledby="pills-gen-info-tab"
              >
                <div class="row g-4">
                  <div class="col-lg-8">
                    <div class="step-intro mb-4">
                      <h5 class="mb-1">
                          <span class="text-primary">{{ user?.nome?.split(' ')[0] }}</span>, vamos começar com os dados iniciais.
                        </h5>
                        <p class="text-muted mb-0">Preencha os campos obrigatórios para iniciar seu atendimento.</p>
                    </div>

                    <div class="card p-3 wizard-summary-card">
                      <div v-if="!documento" class="row">
                        <div class="col-12">
                          <div class="mb-3">
                            <label class="form-label">Informe sua matrícula ou CPF <span class="text-danger">*</span></label>
                            <input
                              autocomplete="off"
                              v-model="sendData.documento"
                              type="text"
                              class="form-control"
                              placeholder="Ex.: 123456 ou 12345678901"
                            />
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-12">
                          <div class="mb-3">
                            <label class="form-label d-flex align-items-center gap-2 fs-16 bold">
                              <span>Qual é o problema? <span class="text-danger">*</span></span>
                              <span v-if="categoriaDestaqueAtivo" class="wizard-required-badge bg-secondary text-white">Ação necessária</span>
                            </label>
                            <div class="wizard-input-hint">Digite palavras-chave para facilitar a busca (ex.: internet lenta, impressora, computador não liga).</div>
                            <div class="multiselect-wrapper categoria-selector">
                              <div v-if="categoriaDestaqueAtivo" class="wizard-required-arrow text-secondary" aria-hidden="true">
                                <span class="wizard-required-arrow-line"></span>
                                <span class="wizard-required-arrow-head"></span>
                              </div>
                              <multiselect
                                ref="multiselectCategoria"
                                @select="changeCategoria"
                                @search-change="buscaCategorias"
                                class="form-control"
                                open-direction="bottom"
                                placeholder="Digite para buscar ou selecione uma categoria"
                                v-model="sendData.categoria"
                                :allow-empty="false"
                                :show-labels="false"
                                :options="categoriasSugestoes"
                                :loading="isLoadingCategorias"
                                :internal-search="false"
                                label="amigavel"
                                track-by="id"
                              >
                                <template #singleLabel="{ option }">
                                  <span class="d-inline-flex align-items-center gap-1 flex-wrap">
                                    <span v-if="option?.recomendado_ia" class="badge bg-success-subtle text-success border">
                                      Recomendado
                                    </span>
                                    <span>{{ option?.amigavel || option?.nome || 'Categoria sem nome' }}</span>
                                    <strong>({{ option?.nome_pai || option?.nome || 'Categoria' }})</strong>
                                  </span>
                                </template>
                                <template #option="{ option }">
                                  <div class="option-content">
                                    <div class="option-name d-flex align-items-center gap-1 flex-wrap">
                                      <span v-if="option?.recomendado_ia" class="badge bg-success-subtle text-success border">
                                        Recomendado
                                      </span>
                                      <span>{{ option?.amigavel || option?.nome || 'Categoria sem nome' }}</span>
                                      <strong>({{ option?.nome_pai || option?.nome || 'Categoria' }})</strong>
                                    </div>
                                  </div>
                                </template>
                                <template #noOptions>
                                  <span>{{ isLoadingCategorias ? "Carregando opções..." : "Digite para buscar uma categoria" }}</span>
                                </template>
                                <template #noResult>
                                  <div v-if="isLoadingCategorias">
                                    <span class="multiselect__option">Carregando opções...</span>
                                  </div>
                                  <div v-else>
                                    <span class="multiselect__option" @click.prevent="selecionarCategoriaPadrao">
                                      <span>
                                        Outros problemas relacionados à Tecnologia da Informação.
                                        <strong>(Suporte)</strong>
                                      </span>
                                    </span>
                                  </div>
                                </template>
                              </multiselect>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row" v-if="isCategoriaEscapeSelecionada">
                        <div class="col-12">
                          <div class="mb-3">
                            <label class="form-label fs-16 bold">
                              Descreva o problema com mais detalhes para recomendação automática <span class="text-danger">*</span>
                            </label>
                            <div class="wizard-input-hint">
                              Vamos analisar esse texto para tentar sugerir uma categoria mais específica.
                            </div>
                            <textarea
                              v-model.trim="detalhamentoCategoriaEscape"
                              rows="4"
                              class="form-control"
                              placeholder="Ex.: Meu computador não liga. Testei outra tomada, mas o LED da fonte não acende."
                            ></textarea>

                            <BAlert
                              v-if="avaliacaoCategoriaEscape.mensagem"
                              :model-value="true"
                              :variant="avaliacaoCategoriaEscape.variant"
                              class="mt-2 mb-0 py-2"
                            >
                              {{ avaliacaoCategoriaEscape.mensagem }}
                            </BAlert>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-12">
                          <div class="mb-3">
                            <label class="form-label fs-16 bold">Para qual localidade <span class="text-primary">(equipamento público)</span> você deseja atendimento? <span class="text-danger">*</span></label>
                            <div class="wizard-input-hint">Isso ajuda a direcionar o chamado para o local e para a fila corretos.</div>
                            <div class="multiselect-wrapper">
                              <multiselect
                                ref="multiselectLocalidade"
                                @select="onSelectLocalidade"
                                @search-change="buscaLocalidades"
                                @close="limparBuscaLocalidade"
                                class="form-control"
                                open-direction="bottom"
                                placeholder="Digite para buscar uma localidade"
                                v-model="sendData.localidade"
                                :allow-empty="false"
                                :show-labels="false"
                                :options="localidadeOpcoesFiltradas"
                                :internal-search="false"
                                label="name"
                                track-by="id"
                              >
                                <template #singleLabel="{ option }">
                                  <span><b>{{ option.name }}</b> - ({{ option.physical_address }})</span>
                                </template>
                                <template #option="{ option }">
                                  <div class="option-content">
                                    <div class="option-name"><b>{{ option.name }}</b> - ({{ option.physical_address }})</div>
                                  </div>
                                </template>
                                <template #noOptions>
                                  <span>
                                    {{ buscaLocalidadeTermo ? "Nenhuma localidade encontrada." : "Digite nome ou endereço para buscar uma localidade" }}
                                  </span>
                                </template>
                                <template #noResult>
                                  <div>
                                  <span v-if="buscaLocalidadeTermo" class="multiselect__option disabled">
                                    Nenhuma localidade encontrada para "{{ buscaLocalidadeTermo }}".
                                  </span>
                                  <span class="multiselect__option" @click.prevent="selecionarLocalidadePadrao">
                                    <span>
                                      PMC - Sede (STI / SEGOV / SECOM / SEAD / SELIC / GERAL / GABINETES)
                                      <strong>(Praça Presidente Tancredo Neves, 200 - Camilo Alves)</strong>
                                    </span>
                                  </span>
                                  </div>
                                </template>
                              </multiselect>
                            </div>
                            <div v-if="mostrarAvisoLocalidadeSugerida" class="mt-3">
                              <BAlert :model-value="true" variant="secondary" class="alert-additional glpi-empty">
                                <div class="alert-body p-2">
                                  <div class="d-flex">
                                    <div class="flex-grow-1">
                                      <h6 class="alert-heading m-0"><strong>Localidade preenchida automaticamente</strong> com base no seu
                                        {{
                                          localidadeSugeridaOrigem === 'ultimo_chamado'
                                            ? 'último chamado'
                                            : ('histórico dos últimos chamados')
                                        }}.</h6>
                                    </div>
                                  </div>
                                </div>

                              </BAlert>
                            </div>

                          </div>
                        </div>
                        <div class="col-12">
                          <button
                            type="button"
                            :disabled="!stepOneReady || isAvaliandoCategoriaEscape || carregandoAvisosChamado"
                            class="btn btn-success btn-label right ms-auto nexttab"
                            @click="onContinuarPrimeiraEtapa"
                          >
                            <span v-if="isAvaliandoCategoriaEscape">Analisando categoria...</span>
                            <span v-else>Continuar</span>
                            <i v-if="!isAvaliandoCategoriaEscape" class="ri-arrow-right-line label-icon align-middle fs-lg ms-2"></i>
                            <span v-else class="spinner-border spinner-border-sm align-middle ms-2" role="status" aria-hidden="true"></span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-4">
                    <div class="wizard-summary-card mb-3">
                      <h6 class="mb-3">Checklist desta etapa</h6>
                      <div class="wizard-checkline">
                        <span>Campos obrigatórios</span>
                        <strong>{{ stepOneAnsweredCount }}/{{ stepOneRequiredCount }}</strong>
                      </div>
                      <div class="progress mb-3 wizard-side-progress">
                        <div class="progress-bar" role="progressbar" :style="`width: ${stepOneProgress}%`"></div>
                      </div>
                      <ul class="wizard-summary-list compact">
                        <li>
                          <span>Categoria</span>
                          <strong>{{ sendData?.categoria ? 'Preenchido' : 'Não selecionada' }}</strong>
                        </li>
                        <li v-if="isCategoriaEscapeSelecionada">
                          <span>Detalhamento de triagem</span>
                          <strong>{{ detalhamentoCategoriaEscapeTrimmed ? 'Informado' : 'Pendente' }}</strong>
                        </li>
                        <li>
                          <span>Localidade</span>
                          <strong>{{ sendData?.localidade?.name ? 'Preenchido' : 'Não selecionada' }}</strong>
                        </li>
                        <li>
                          <span>Status</span>
                          <strong>{{ stepOneReady ? 'Pronto para avançar' : 'Preencha os campos obrigatórios' }}</strong>
                        </li>
                        <li v-if="avisosBloqueantesChamado.length > 0">
                          <span>Avisos obrigatórios</span>
                          <strong>
                            {{
                              avisosPendentesConfirmacaoChamado > 0
                                ? `${avisosPendentesConfirmacaoChamado} pendente(s)`
                                : 'Ciente'
                            }}
                          </strong>
                        </li>
                      </ul>
                      <div class="wizard-summary-tip" v-if="!stepOneReady">
                        Faltam {{ stepOneMissingCount }} campo(s) obrigatório(s).
                      </div>
                    </div>

                    <div class="wizard-summary-card">
                      <h6 class="mb-3">Resumo do preenchimento</h6>
                      <ul class="wizard-summary-list">
                        <li>
                          <span>Solicitante</span>
                          <strong>{{ sendData.solicitante || '-' }}</strong>
                        </li>
                        <li>
                          <span>Matrícula</span>
                          <strong>{{ sendData.documento || '-' }}</strong>
                        </li>
                        <li>
                          <span>Categoria</span>
                          <strong>{{ obterCategoriaLabel(sendData?.categoria) }}</strong>
                        </li>
                        <li>
                          <span>Localidade</span>
                          <strong>{{ sendData?.localidade?.name || '-' }}</strong>
                        </li>
                      </ul>
                      <div class="wizard-summary-tip">
                        Ao avançar, exibiremos as perguntas específicas da categoria selecionada.
                      </div>
                    </div>
                  </div>
                </div>

                <div class="d-flex align-items-start gap-3 mt-4">
                  <button
                    type="button"
                    :disabled="!stepOneReady || isAvaliandoCategoriaEscape || carregandoAvisosChamado"
                    class="btn btn-success btn-label right ms-auto nexttab"
                    @click="onContinuarPrimeiraEtapa"
                  >
                    <span v-if="isAvaliandoCategoriaEscape">Analisando categoria...</span>
                    <span v-else>Continuar</span>
                    <i v-if="!isAvaliandoCategoriaEscape" class="ri-arrow-right-line label-icon align-middle fs-lg ms-2"></i>
                    <span v-else class="spinner-border spinner-border-sm align-middle ms-2" role="status" aria-hidden="true"></span>
                  </button>
                </div>
              </div>

              <div
                class="tab-pane fade step-pane"
                :class="activeTab == 2 && 'show active'"
                id="pills-info-desc"
                role="tabpanel"
                aria-labelledby="pills-info-desc-tab"
              >
                <div class="row g-4">
                  <div class="col-lg-8">
                    <div class="d-flex flex-wrap justify-content-between align-items-center mb-3 gap-2">
                      <div>
                        <h5 class="mb-1">
                          <span class="text-primary">{{ user?.nome?.split(' ')[0] }}</span>, agora descreva seu problema.
                        </h5>
                        <p class="text-muted mb-0">Responda os campos obrigatórios para agilizar seu atendimento.</p>
                      </div>
                      <span class="badge text-bg-light border">
                        {{ questionAnsweredCount }}/{{ questionRequiredCount }} obrigatórios preenchidos
                      </span>
                    </div>

                    <div
                      v-if="avisosPasso2.length > 0"
                      id="avisos-passo2-cau"
                      class="avc-inline mb-4"
                    >
                      <div class="avc-inline__head">
                        <i class="ri-notification-3-line"></i>
                        <span class="avc-inline__title">Avisos para esta etapa</span>
                        <span v-if="avisosPasso2Pendentes > 0" class="avc-inline__badge">
                          {{ avisosPasso2Pendentes }} obrigatório(s) pendente(s)
                        </span>
                      </div>
                      <div class="avc-list">
                        <div
                          v-for="avisoItem in avisosPasso2"
                          :key="`aviso-inline-${avisoItem.id}`"
                          class="avc-item"
                          :class="`avc-item--${getAvisoChamadoVariant(avisoItem.tipo)}`"
                        >
                          <div class="avc-item__icon"><i :class="getAvisoChamadoIcon(avisoItem.tipo)"></i></div>
                          <div class="avc-item__content">
                            <div class="avc-item__head">
                              <span class="avc-tag">{{ getAvisoChamadoTipoLabel(avisoItem.tipo) }}</span>
                              <span v-if="toBool(avisoItem.bloqueia_continuar, false)" class="avc-tag avc-tag--req">
                                <i class="ri-lock-line me-1"></i>Obrigatório
                              </span>
                            </div>
                            <p v-if="avisoItem.titulo" class="avc-item__title mb-1">{{ avisoItem.titulo }}</p>
                            <p class="avc-item__msg mb-0">{{ avisoItem.mensagem }}</p>

                            <div v-if="toBool(avisoItem.bloqueia_continuar, false)" class="form-check mt-2 mb-0">
                              <input
                                :id="`aviso-inline-ciente-${avisoItem.id}`"
                                class="form-check-input"
                                type="checkbox"
                                :checked="isAvisoChamadoConfirmado(avisoItem.id)"
                                @change="alternarConfirmacaoAvisoChamado(avisoItem.id, $event.target.checked)"
                              />
                              <label class="form-check-label" :for="`aviso-inline-ciente-${avisoItem.id}`">
                                Li e estou ciente deste aviso.
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="perguntasRenderizadas.length > 0">
                      <div :key="`p-${index}`" v-for="(perguntaItem,index) in perguntasRenderizadas" class="row">
                        <div class="col-12">
                          <div class="mb-3">
                            <label class="form-label">
                              {{ perguntaItem.pergunta }}
                              <span v-if="!isPerguntaOpcional(index)" class="text-danger">*</span>
                              <span v-else class="badge bg-light text-muted border ms-2">Opcional</span>
                            </label>

                            <input
                              autocomplete="off"
                              v-if="index === 0"
                              v-model="perguntas[perguntaItem.pergunta]"
                              type="text"
                              v-mask="['(##) ####-####', '(##) #####-####']"
                              class="form-control"
                              inputmode="tel"
                              placeholder="Informe um número de telefone ou WhatsApp"
                            />

                            <textarea
                              v-else-if="isPerguntaOpcional(index)"
                              v-model="perguntas[perguntaItem.pergunta]"
                              rows="8"
                              class="form-control w-100"
                              placeholder="Gostaria de adicionar mais algum detalhe para nos ajudar no atendimento?"
                            ></textarea>

                            <textarea
                              v-else-if="perguntaItem.tipo === 'textarea'"
                              v-model="perguntas[perguntaItem.pergunta]"
                              rows="5"
                              class="form-control w-100"
                              placeholder="Preenchimento obrigatório"
                            ></textarea>

                            <input
                              v-else-if="perguntaItem.tipo === 'date'"
                              v-model="perguntas[perguntaItem.pergunta]"
                              type="date"
                              class="form-control"
                            />

                            <select
                              v-else-if="perguntaItem.tipo === 'select'"
                              v-model="perguntas[perguntaItem.pergunta]"
                              class="form-control"
                            >
                              <option value="">Selecione uma opção</option>
                              <option
                                v-for="(opcao, opIndex) in perguntaItem.opcoes"
                                :key="`sel-${index}-${opIndex}`"
                                :value="opcao"
                              >
                                {{ opcao }}
                              </option>
                            </select>

                            <multiselect
                              v-else-if="perguntaItem.tipo === 'multiselect'"
                              v-model="perguntas[perguntaItem.pergunta]"
                              :options="perguntaItem.opcoes"
                              :multiple="true"
                              :close-on-select="false"
                              :show-labels="false"
                              :allow-empty="true"
                              class="form-control"
                              open-direction="bottom"
                              placeholder="Selecione uma ou mais opções"
                            >
                              <template #noOptions><span>Nenhuma opção disponível.</span></template>
                              <template #noResult><span>Nenhuma opção encontrada.</span></template>
                            </multiselect>

                            <multiselect
                              v-else-if="perguntaItem.tipo === 'singleselect'"
                              v-model="perguntas[perguntaItem.pergunta]"
                              :options="perguntaItem.opcoes"
                              :multiple="false"
                              :searchable="true"
                              :show-labels="false"
                              :allow-empty="true"
                              :loading="perguntaItem.pergunta === perguntaSetorTexto && carregandoSetoresUnidade"
                              class="form-control"
                              open-direction="bottom"
                              placeholder="Digite para buscar..."
                            >
                              <template #noOptions><span>Nenhuma opção disponível.</span></template>
                              <template #noResult><span>Nenhuma opção encontrada.</span></template>
                            </multiselect>

                            <div v-else-if="perguntaItem.tipo === 'radio'" class="d-flex flex-column gap-2">
                              <div
                                v-for="(opcao, opIndex) in perguntaItem.opcoes"
                                :key="`radio-${index}-${opIndex}`"
                                class="form-check"
                              >
                                <input
                                  :id="`pergunta-radio-${index}-${opIndex}`"
                                  v-model="perguntas[perguntaItem.pergunta]"
                                  :value="opcao"
                                  class="form-check-input"
                                  type="radio"
                                />
                                <label class="form-check-label" :for="`pergunta-radio-${index}-${opIndex}`">
                                  {{ opcao }}
                                </label>
                              </div>
                            </div>

                            <div v-else-if="perguntaItem.tipo === 'checkbox'" class="d-flex flex-column gap-2">
                              <div
                                v-for="(opcao, opIndex) in perguntaItem.opcoes"
                                :key="`check-${index}-${opIndex}`"
                                class="form-check"
                              >
                                <input
                                  :id="`pergunta-check-${index}-${opIndex}`"
                                  v-model="perguntas[perguntaItem.pergunta]"
                                  :value="opcao"
                                  class="form-check-input"
                                  type="checkbox"
                                />
                                <label class="form-check-label" :for="`pergunta-check-${index}-${opIndex}`">
                                  {{ opcao }}
                                </label>
                              </div>
                            </div>

                            <input
                              autocomplete="off"
                              v-else-if="perguntaItem.mascara"
                              v-model="perguntas[perguntaItem.pergunta]"
                              type="text"
                              v-mask="perguntaItem.mascara"
                              class="form-control"
                              placeholder="Preenchimento obrigatório"
                            />

                            <input
                              autocomplete="off"
                              v-else
                              v-model="perguntas[perguntaItem.pergunta]"
                              type="text"
                              class="form-control"
                              placeholder="Preenchimento obrigatório"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="mt-3">
                      <FotosChamado ref="fotosChamado" :usuario-id="0" />
                    </div>
                  </div>

                  <div class="col-lg-4">
                    <div class="wizard-summary-card">
                      <h6 class="mb-3">Checklist desta etapa</h6>
                      <div class="wizard-checkline">
                        <span>Campos obrigatórios</span>
                        <strong>{{ questionAnsweredCount }}/{{ questionRequiredCount }}</strong>
                      </div>
                      <div class="progress mb-3 wizard-side-progress">
                        <div class="progress-bar" role="progressbar" :style="`width: ${requiredProgress}%`"></div>
                      </div>
                      <ul class="wizard-summary-list compact">
                        <li>
                          <span>Categoria</span>
                          <strong>{{ obterCategoriaLabel(sendData?.categoria) }}</strong>
                        </li>
                        <li>
                          <span>Localidade</span>
                          <strong>{{ sendData?.localidade?.name || '-' }}</strong>
                        </li>
                        <li>
                          <span>Status</span>
                          <strong>Nova</strong>
                        </li>
                      </ul>
                      <div class="wizard-summary-tip" v-if="!autoriza">
                        Faltam {{ faltamPerguntasObrigatorias }} campo(s) obrigatório(s).
                      </div>
                    </div>
                  </div>
                </div>

                <div class="d-flex align-items-start gap-3 mt-4">
                  <button
                    type="button"
                    class="btn btn-link text-decoration-none btn-label previestab"
                    :disabled="isSubmitting"
                    @click="toggleTab(1, 0)"
                  >
                    <i class="ri-arrow-left-line label-icon align-middle fs-lg me-2"></i>
                    Voltar
                  </button>
                  <button
                    type="button"
                    :disabled="!autoriza || isSubmitting"
                    class="btn btn-success btn-label right ms-auto nexttab"
                    @click="abrirChamado"
                  >
                    <span v-if="isSubmitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    {{ isSubmitting ? 'Abrindo chamado...' : 'Abrir chamado' }}
                    <i v-if="!isSubmitting" class="ri-arrow-right-line label-icon align-middle fs-lg ms-2"></i>
                  </button>
                </div>
              </div>

              <div
                class="tab-pane fade step-pane"
                :class="activeTab == 3 && 'show active'"
                id="pills-success"
                role="tabpanel"
                aria-labelledby="pills-success-tab"
              >
                <div class="wizard-success text-center py-4">
                  <div class="avatar-md mx-auto mb-4">
                    <lottie colors="primary:#0ab39c,secondary:#405189" :options="defaultOptions" :height="120" :width="120" />
                  </div>
                  <h5>Chamado aberto com sucesso, <span class="text-primary">{{ user?.nome?.split(' ')[0] || 'usuário' }}</span>!</h5>
                  <p class="text-muted mb-0">
                    O seu chamado
                    <strong class="text-success-emphasis">nº: {{ resumoFinalChamado?.id || '-' }}</strong>,
                    foi aberto com sucesso!
                  </p>

                  <div v-if="resumoFinalChamado" class="wizard-success-summary text-start mt-4 mx-auto">
                    <h6 class="mb-3">Resumo do chamado aberto</h6>
                    <div class="row g-2">
                      <div class="col-md-6">
                        <div class="summary-item">
                          <span>Número do chamado</span>
                          <strong>#{{ resumoFinalChamado.id || '-' }}</strong>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="summary-item">
                          <span>Solicitante</span>
                          <strong>{{ resumoFinalChamado.solicitante || '-' }}</strong>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="summary-item">
                          <span>Matrícula</span>
                          <strong>{{ resumoFinalChamado.documento || '-' }}</strong>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="summary-item">
                          <span>Telefone</span>
                          <strong>{{ resumoFinalChamado.telefone || '-' }}</strong>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="summary-item">
                          <span>Categoria</span>
                          <strong>{{ resumoFinalChamado.categoria || '-' }}</strong>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="summary-item">
                          <span>Localidade</span>
                          <strong>{{ resumoFinalChamado.localidade || '-' }}</strong>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="summary-item">
                          <span>Endereço da localidade</span>
                          <strong>{{ resumoFinalChamado.endereco || '-' }}</strong>
                        </div>
                      </div>
                    </div>

                    <div v-if="resumoFinalChamado.respostas && resumoFinalChamado.respostas.length > 0" class="summary-questions mt-3">
                      <h6 class="mb-2">Respostas enviadas</h6>
                      <div class="summary-question" v-for="(item, index) in resumoFinalChamado.respostas" :key="`resumo-${index}`">
                        <span>{{ item.pergunta }}</span>
                        <strong>{{ item.resposta }}</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </BCardBody>
      </BCard>
    </BCol>
  </BRow>
  <BModal
    v-model="modalAvisosChamadoAberto"
    modal-class="zoomIn avc-modal"
    centered
    size="lg"
    hide-header
    hide-footer
    body-class="p-0"
  >
    <div class="avc-shell">
      <div class="avc-hero">
        <div class="d-flex align-items-start justify-content-between gap-3">
          <div class="flex-grow-1">
            <div class="avc-kicker"><i class="ri-notification-3-line me-1"></i>Avisos importantes</div>
            <h4 class="avc-title mb-1">Antes de continuar</h4>
            <p class="avc-subtitle mb-0">Revise os avisos abaixo referentes à categoria e localidade selecionadas.</p>
          </div>
          <button
            type="button"
            class="btn-close avc-close"
            aria-label="Fechar"
            @click="modalAvisosChamadoAberto = false"
          ></button>
        </div>
        <div class="avc-pills">
          <span class="avc-pill avc-pill--count">
            <i class="ri-file-list-3-line me-1"></i>{{ avisosPasso1.length }} aviso(s)
          </span>
          <span
            v-if="avisosBloqueantesChamado.length > 0"
            class="avc-pill"
            :class="avisosPendentesConfirmacaoChamado > 0 ? 'avc-pill--pending' : 'avc-pill--ok'"
          >
            <i :class="avisosPendentesConfirmacaoChamado > 0 ? 'ri-lock-line' : 'ri-checkbox-circle-line'" class="me-1"></i>
            {{ avisosPendentesConfirmacaoChamado > 0
              ? `${avisosPendentesConfirmacaoChamado} obrigatório(s) pendente(s)`
              : 'Obrigatórios confirmados' }}
          </span>
        </div>
      </div>

      <div class="avc-body">
        <div v-if="carregandoAvisosChamado" class="d-flex align-items-center gap-2 text-muted">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <span>Verificando avisos...</span>
        </div>

        <BAlert v-else-if="avisoChamadoErro" :model-value="true" variant="warning" class="mb-0">
          {{ avisoChamadoErro }}
        </BAlert>

        <div v-else-if="avisosPasso1.length === 0" class="text-muted">
          Nenhum aviso encontrado para a seleção atual.
        </div>

        <div v-else class="avc-list">
          <div
            v-for="avisoItem in avisosPasso1"
            :key="`aviso-modal-${avisoItem.id}`"
            class="avc-item"
            :class="`avc-item--${getAvisoChamadoVariant(avisoItem.tipo)}`"
          >
            <div class="avc-item__icon"><i :class="getAvisoChamadoIcon(avisoItem.tipo)"></i></div>
            <div class="avc-item__content">
              <div class="avc-item__head">
                <span class="avc-tag">{{ getAvisoChamadoTipoLabel(avisoItem.tipo) }}</span>
                <span v-if="toBool(avisoItem.bloqueia_continuar, false)" class="avc-tag avc-tag--req">
                  <i class="ri-lock-line me-1"></i>Obrigatório
                </span>
              </div>
              <p v-if="avisoItem.titulo" class="avc-item__title mb-1">{{ avisoItem.titulo }}</p>
              <p class="avc-item__msg mb-0">{{ avisoItem.mensagem }}</p>

              <div v-if="toBool(avisoItem.bloqueia_continuar, false)" class="form-check mt-2 mb-0">
                <input
                  :id="`aviso-modal-ciente-${avisoItem.id}`"
                  class="form-check-input"
                  type="checkbox"
                  :checked="isAvisoChamadoConfirmado(avisoItem.id)"
                  @change="alternarConfirmacaoAvisoChamado(avisoItem.id, $event.target.checked)"
                />
                <label class="form-check-label" :for="`aviso-modal-ciente-${avisoItem.id}`">
                  Li e estou ciente deste aviso.
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="avc-footer">
        <BButton variant="light" @click="modalAvisosChamadoAberto = false">Fechar</BButton>
        <BButton
          variant="success"
          :disabled="carregandoAvisosChamado || isAvaliandoCategoriaEscape || avisosPendentesConfirmacaoChamado > 0"
          @click="confirmarAvisosEContinuar"
        >
          <i class="ri-arrow-right-line me-1"></i>Continuar
        </BButton>
      </div>
    </div>
  </BModal>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.ticket-wizard {
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  color: #334155;
  border-radius: 1.25rem;
  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;
}

.ticket-wizard .wizard-header {
  margin-bottom: 1.2rem;
}

.ticket-wizard .wizard-kicker {
  display: inline-block;
  padding: 0.2rem 0.6rem;
  border-radius: 999px;
  background: #eaf3ff;
  color: #0b5ed7;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 0.6rem;
}

.ticket-wizard .wizard-progress-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.4rem;
  font-size: 0.79rem;
  color: #51627b;
}

/* Sobrescreve o estilo global de .progress-nav (que posiciona absolute). */
.ticket-wizard .progress-nav {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.ticket-wizard .progress-nav .progress {
  position: relative !important;
  left: auto !important;
  top: auto !important;
  transform: none !important;
  width: 100% !important;
}

.ticket-wizard .progress-nav .nav {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.ticket-wizard .wizard-progress {
  height: 6px;
  border-radius: 999px;
  background-color: #e9eef6;
  margin-bottom: 0.9rem;
}

.ticket-wizard .wizard-progress .progress-bar {
  border-radius: 999px;
  background: linear-gradient(90deg, #22c55e 0%, #0ea5e9 100%);
}

.ticket-wizard .wizard-steps {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.75rem;
}

.ticket-wizard .wizard-steps .nav-link {
  width: 100% !important;
  height: auto !important;
  display: flex;
  align-items: center;
  gap: 0.65rem;
  border-radius: 12px;
  border: 1px solid #d6dfeb;
  background: #f8fafc;
  color: #334155 !important;
  padding: 0.85rem 0.9rem;
  padding-left: 1.1rem !important;
  min-height: 74px;
  text-align: left;
}

.ticket-wizard .wizard-steps .nav-link.active,
.ticket-wizard .wizard-steps .nav-link.done {
  border-color: #93c5fd !important;
  background: #eff6ff !important;
  color: #1e3a8a !important;
}

.ticket-wizard .wizard-steps .nav-link.active .wizard-step-meta small,
.ticket-wizard .wizard-steps .nav-link.done .wizard-step-meta small {
  color: #51627b !important;
}

.ticket-wizard .wizard-steps .nav-link.active .wizard-step-index,
.ticket-wizard .wizard-steps .nav-link.done .wizard-step-index {
  background: #2563eb !important;
  color: #ffffff !important;
}

.ticket-wizard .wizard-step-index {
  height: 34px;
  width: 34px;
  min-width: 34px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.88rem;
  font-weight: 700;
  background: #dbeafe;
  color: #1d4ed8;
}

.ticket-wizard .wizard-step-meta {
  display: flex;
  flex-direction: column;
  line-height: 1.15;
}

.ticket-wizard .wizard-step-title {
  font-size: 0.83rem;
  font-weight: 600;
}

.ticket-wizard .wizard-step-meta small {
  font-size: 0.72rem;
  color: #64748b;
}

.ticket-wizard .step-pane {
  animation: wizardFadeUp 0.28s ease;
}

.ticket-wizard .wizard-input-hint {
  font-size: 0.77rem;
  color: #64748b;
  margin-bottom: 0.45rem;
}

.ticket-wizard .wizard-required-badge {
  border-radius: 999px;
  font-size: 0.66rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  line-height: 1;
  padding: 0.28rem 0.5rem;
  text-transform: uppercase;
}

.ticket-wizard .categoria-selector {
  position: relative;
}

.ticket-wizard .wizard-required-arrow {
  position: absolute;
  top: 50%;
  left: -2.45rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  pointer-events: none;
  z-index: 2;
  transform: translateY(-50%);
  animation: wizardRequiredArrow 1.1s ease-in-out infinite;
}

.ticket-wizard .wizard-required-arrow-line {
  width: 26px;
  height: 4px;
  border-radius: 999px;
  background: currentColor;
}

.ticket-wizard .wizard-required-arrow-head {
  width: 0;
  height: 0;
  margin-left: -1px;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
  border-left: 10px solid currentColor;
}

.ticket-wizard .wizard-summary-card {
  background: #f8fbff;
  border: 1px solid #d9e7f7;
  border-radius: 14px;
  padding: 1rem;
  position: sticky;
  top: 0.8rem;
}

.ticket-wizard .wizard-summary-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.ticket-wizard .wizard-summary-list li {
  display: flex;
  flex-direction: column;
  padding: 0.45rem 0;
  border-bottom: 1px dashed #d8e3f1;
}

.ticket-wizard .wizard-summary-list li:last-child {
  border-bottom: 0;
}

.ticket-wizard .wizard-summary-list span {
  font-size: 0.74rem;
  color: #64748b;
  margin-bottom: 0.15rem;
}

.ticket-wizard .wizard-summary-list strong {
  font-size: 0.85rem;
  color: #0f172a;
  font-weight: 600;
}

.ticket-wizard .wizard-summary-list.compact strong {
  font-size: 0.82rem;
}

.ticket-wizard .wizard-summary-tip {
  margin-top: 0.8rem;
  padding-top: 0.8rem;
  border-top: 1px solid #dde8f6;
  font-size: 0.78rem;
  color: #51627b;
}

.ticket-wizard .wizard-checkline {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.8rem;
  color: #475569;
  margin-bottom: 0.5rem;
}

.ticket-wizard .wizard-side-progress {
  height: 6px;
  border-radius: 999px;
  background-color: #e9eef6;
}

.ticket-wizard .wizard-side-progress .progress-bar {
  border-radius: 999px;
  background: linear-gradient(90deg, #22c55e 0%, #0ea5e9 100%);
}

.ticket-wizard .wizard-success {
  border: 1px solid #d6f2e2;
  background: linear-gradient(180deg, #f4fff8 0%, #ffffff 100%);
  border-radius: 14px;
}

.ticket-wizard .wizard-success-summary {
  max-width: 900px;
  border-top: 1px solid #d8e8dc;
  padding-top: 1rem;
}

.ticket-wizard .wizard-success-summary .summary-item {
  background: #f8fbff;
  border: 1px solid #d9e7f7;
  border-radius: 10px;
  padding: 0.65rem 0.75rem;
  display: flex;
  flex-direction: column;
  min-height: 64px;
}

.ticket-wizard .wizard-success-summary .summary-item span {
  font-size: 0.73rem;
  color: #64748b;
  margin-bottom: 0.1rem;
}

.ticket-wizard .wizard-success-summary .summary-item strong {
  font-size: 0.86rem;
  color: #0f172a;
  font-weight: 600;
  word-break: break-word;
}

.ticket-wizard .wizard-success-summary .summary-questions {
  border-top: 1px dashed #cddfea;
  padding-top: 0.75rem;
}

.ticket-wizard .wizard-success-summary .summary-question {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  padding: 0.5rem 0.1rem;
  border-bottom: 1px dashed #e2e8f0;
}

.ticket-wizard .wizard-success-summary .summary-question:last-child {
  border-bottom: 0;
}

.ticket-wizard .wizard-success-summary .summary-question span {
  font-size: 0.78rem;
  color: #334155;
}

.ticket-wizard .wizard-success-summary .summary-question strong {
  font-size: 0.85rem;
  color: #0f172a;
  font-weight: 600;
  white-space: pre-wrap;
}

.ticket-wizard .form-control {
  border: 1px solid #c8d2df !important;
  background: #ffffff;
  color: #0f172a;
}

[data-bs-theme="dark"] .ticket-wizard .form-control {
  border: 1px solid rgba(148, 163, 184, 0.2) !important;
  background: rgba(8, 15, 28, 0.86);
  color: #dbe7f4;
}

.ticket-wizard .multiselect__option {
  color: #0f172a;
}

.ticket-wizard .multiselect__option--selected,
.ticket-wizard .multiselect__option--selected::after {
  background: rgba(var(--vz-primary-rgb, 64, 81, 137), 0.12) !important;
  color: var(--vz-primary, #405189) !important;
}

.ticket-wizard .multiselect__option--highlight,
.ticket-wizard .multiselect__option--highlight::after {
  background: rgba(var(--vz-primary-rgb, 64, 81, 137), 0.08) !important;
  color: #0f172a !important;
}

.ticket-wizard .multiselect__option--selected.multiselect__option--highlight,
.ticket-wizard .multiselect__option--selected.multiselect__option--highlight::after {
  background: rgba(var(--vz-primary-rgb, 64, 81, 137), 0.18) !important;
  color: var(--vz-primary, #405189) !important;
}

.multiselect {
  border: 1px solid #c8d2df !important;
}

.multiselect.form-control .multiselect__input,
.multiselect.form-control .multiselect__single {
  background: inherit;
  color: inherit;
}

.multiselect.form-control.multiselect--active .multiselect__tags {
  box-shadow: none;
}

.multiselect.form-control .multiselect__content-wrapper {
  background: var(--bs-body-bg, white);
  color: var(--bs-body-color, black);
  border: 1px solid #c8d2df !important;
}

.multiselect-wrapper .multiselect__tags {
  background: inherit;
  color: inherit;
  display: block;
  width: 100%;
  font-size: 0.825rem;
  font-weight: 400;
  line-height: 1.5;
  border: none;
}

.multiselect-wrapper .multiselect__input,
.multiselect-wrapper .multiselect__single {
  font-size: 0.825rem;
  margin-bottom: 0.125rem;
  background: inherit;
  color: inherit;
  border: inherit;
}

[data-bs-theme="dark"] .ticket-wizard {
  background: linear-gradient(180deg, rgba(8, 15, 28, 0.98) 0%, rgba(13, 23, 40, 0.96) 100%);
  color: #dbe7f4;
  border: 1px solid rgba(148, 163, 184, 0.16);
  box-shadow: 0 22px 40px rgba(2, 8, 20, 0.32);
}

[data-bs-theme="dark"] .ticket-wizard .wizard-header h4,
[data-bs-theme="dark"] .ticket-wizard h5,
[data-bs-theme="dark"] .ticket-wizard h6,
[data-bs-theme="dark"] .ticket-wizard .form-label,
[data-bs-theme="dark"] .ticket-wizard .wizard-step-title,
[data-bs-theme="dark"] .ticket-wizard .wizard-summary-list strong,
[data-bs-theme="dark"] .ticket-wizard .wizard-checkline strong,
[data-bs-theme="dark"] .ticket-wizard .wizard-success-summary .summary-item strong,
[data-bs-theme="dark"] .ticket-wizard .wizard-success-summary .summary-question strong {
  color: #eff6ff;
}

[data-bs-theme="dark"] .ticket-wizard .text-muted,
[data-bs-theme="dark"] .ticket-wizard .wizard-progress-meta,
[data-bs-theme="dark"] .ticket-wizard .wizard-step-meta small,
[data-bs-theme="dark"] .ticket-wizard .wizard-input-hint,
[data-bs-theme="dark"] .ticket-wizard .wizard-summary-list span,
[data-bs-theme="dark"] .ticket-wizard .wizard-summary-tip,
[data-bs-theme="dark"] .ticket-wizard .wizard-checkline,
[data-bs-theme="dark"] .ticket-wizard .wizard-success-summary .summary-item span,
[data-bs-theme="dark"] .ticket-wizard .wizard-success-summary .summary-question span {
  color: #94a9c6 !important;
}

[data-bs-theme="dark"] .ticket-wizard .wizard-progress,
[data-bs-theme="dark"] .ticket-wizard .wizard-side-progress {
  background-color: rgba(51, 65, 85, 0.72);
}

[data-bs-theme="dark"] .ticket-wizard .wizard-steps .nav-link {
  border-color: rgba(148, 163, 184, 0.16);
  background: rgba(15, 23, 42, 0.7);
  color: #dbe7f4 !important;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03);
}

[data-bs-theme="dark"] .ticket-wizard .wizard-steps .nav-link.active,
[data-bs-theme="dark"] .ticket-wizard .wizard-steps .nav-link.done {
  border-color: rgba(96, 165, 250, 0.4) !important;
  background: linear-gradient(180deg, rgba(30, 64, 175, 0.26) 0%, rgba(17, 24, 39, 0.9) 100%) !important;
  color: #eff6ff !important;
}

[data-bs-theme="dark"] .ticket-wizard .wizard-steps .nav-link.active .wizard-step-meta small,
[data-bs-theme="dark"] .ticket-wizard .wizard-steps .nav-link.done .wizard-step-meta small {
  color: #bfd3ee !important;
}

[data-bs-theme="dark"] .ticket-wizard .wizard-step-index {
  background: rgba(59, 130, 246, 0.18);
  color: #93c5fd;
}

[data-bs-theme="dark"] .ticket-wizard .wizard-steps .nav-link.active .wizard-step-index,
[data-bs-theme="dark"] .ticket-wizard .wizard-steps .nav-link.done .wizard-step-index {
  background: #3b82f6 !important;
  color: #ffffff !important;
}

[data-bs-theme="dark"] .ticket-wizard .wizard-summary-card {
  background: rgba(11, 19, 34, 0.72);
  border-color: rgba(148, 163, 184, 0.16);
  box-shadow: 0 18px 30px rgba(2, 8, 20, 0.18);
}

[data-bs-theme="dark"] .ticket-wizard .wizard-summary-list li,
[data-bs-theme="dark"] .ticket-wizard .wizard-success-summary,
[data-bs-theme="dark"] .ticket-wizard .wizard-summary-tip,
[data-bs-theme="dark"] .ticket-wizard .wizard-success-summary .summary-questions,
[data-bs-theme="dark"] .ticket-wizard .wizard-success-summary .summary-question {
  border-color: rgba(71, 85, 105, 0.72);
}

[data-bs-theme="dark"] .ticket-wizard .wizard-success {
  border-color: rgba(34, 197, 94, 0.16);
  background: linear-gradient(180deg, rgba(9, 20, 30, 0.98) 0%, rgba(13, 23, 40, 0.94) 100%);
}

[data-bs-theme="dark"] .ticket-wizard .wizard-success-summary .summary-item {
  background: rgba(11, 19, 34, 0.78);
  border-color: rgba(148, 163, 184, 0.16);
}

[data-bs-theme="dark"] .ticket-wizard .wizard-success .text-success-emphasis {
  color: #86efac !important;
}

[data-bs-theme="dark"] .ticket-wizard .badge.text-bg-light,
[data-bs-theme="dark"] .ticket-wizard .badge.bg-light.text-muted.border {
  background: rgba(148, 163, 184, 0.12) !important;
  color: #c8d7ea !important;
  border-color: rgba(148, 163, 184, 0.16) !important;
}

[data-bs-theme="dark"] .ticket-wizard .wizard-required-badge.bg-secondary {
  background: rgba(129, 140, 248, 0.16) !important;
  color: #c7d2fe !important;
}

[data-bs-theme="dark"] .ticket-wizard .wizard-required-arrow.text-secondary {
  color: #a78bfa !important;
}

[data-bs-theme="dark"] .ticket-wizard .alert-secondary {
  background: rgba(96, 165, 250, 0.12);
  border-color: rgba(96, 165, 250, 0.22);
  color: #dbeafe;
}

[data-bs-theme="dark"] .ticket-wizard .alert-heading,
[data-bs-theme="dark"] .ticket-wizard .alert-body {
  color: inherit;
}

[data-bs-theme="dark"] .ticket-wizard .btn-link {
  color: #93c5fd;
}

[data-bs-theme="dark"] .ticket-wizard .btn-link:hover,
[data-bs-theme="dark"] .ticket-wizard .btn-link:focus {
  color: #bfdbfe;
}

[data-bs-theme="dark"] .ticket-wizard .form-control::placeholder,
[data-bs-theme="dark"] .ticket-wizard .multiselect__placeholder {
  color: #7f95b0;
}

[data-bs-theme="dark"] .ticket-wizard select.form-control option {
  background: #0f172a;
  color: #e2e8f0;
}

[data-bs-theme="dark"] .ticket-wizard .form-check-label {
  color: #dbe7f4;
}

[data-bs-theme="dark"] .ticket-wizard .form-check-input {
  background-color: rgba(8, 15, 28, 0.86);
  border-color: rgba(148, 163, 184, 0.28);
}

[data-bs-theme="dark"] .ticket-wizard .form-check-input:checked {
  background-color: #22c55e;
  border-color: #22c55e;
}

[data-bs-theme="dark"] .ticket-wizard .multiselect {
  background: rgba(8, 15, 28, 0.86);
  border-color: rgba(148, 163, 184, 0.2) !important;
}

[data-bs-theme="dark"] .ticket-wizard .multiselect-wrapper .multiselect__tags {
  background: transparent;
  color: #dbe7f4;
}

[data-bs-theme="dark"] .ticket-wizard .multiselect.form-control .multiselect__input,
[data-bs-theme="dark"] .ticket-wizard .multiselect.form-control .multiselect__single,
[data-bs-theme="dark"] .ticket-wizard .multiselect-wrapper .multiselect__input,
[data-bs-theme="dark"] .ticket-wizard .multiselect-wrapper .multiselect__single {
  color: #dbe7f4;
}

[data-bs-theme="dark"] .ticket-wizard .multiselect__select::before {
  border-top-color: #8ea3bd;
}

[data-bs-theme="dark"] .ticket-wizard .multiselect.form-control .multiselect__content-wrapper {
  background: #0f172a;
  color: #dbe7f4;
  border: 1px solid rgba(148, 163, 184, 0.16) !important;
  box-shadow: 0 18px 28px rgba(2, 8, 20, 0.32);
}

[data-bs-theme="dark"] .ticket-wizard .multiselect__option {
  background: transparent;
  color: #dbe7f4;
}

[data-bs-theme="dark"] .ticket-wizard .multiselect__option--highlight,
[data-bs-theme="dark"] .ticket-wizard .multiselect__option--highlight::after {
  background: rgba(59, 130, 246, 0.18) !important;
  color: #eff6ff !important;
}

[data-bs-theme="dark"] .ticket-wizard .multiselect__option--selected,
[data-bs-theme="dark"] .ticket-wizard .multiselect__option--selected::after {
  background: rgba(30, 41, 59, 0.88) !important;
  color: #dbe7f4 !important;
}

[data-bs-theme="dark"] .ticket-wizard .multiselect__option--selected.multiselect__option--highlight,
[data-bs-theme="dark"] .ticket-wizard .multiselect__option--selected.multiselect__option--highlight::after {
  background: rgba(59, 130, 246, 0.28) !important;
  color: #ffffff !important;
}

@keyframes wizardFadeUp {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes wizardRequiredArrow {
  0%,
  100% {
    opacity: 0.65;
    transform: translateY(-50%) translateX(-1px);
  }
  50% {
    opacity: 1;
    transform: translateY(-50%) translateX(3px);
  }
}

@media (max-width: 991.98px) {
  .ticket-wizard .wizard-required-arrow {
    left: -1.45rem;
  }

  .ticket-wizard .wizard-summary-card {
    position: static;
  }

  .ticket-wizard .wizard-steps .nav-link {
    padding: 0.7rem 0.65rem;
    padding-left: 0.85rem !important;
    min-height: 62px;
  }

  .ticket-wizard .wizard-step-meta small {
    display: none;
  }
}

/* ===================== Avisos do chamado (modal premium + inline) ===================== */
.avc-modal .modal-content {
  border: 0;
  border-radius: 1rem;
  overflow: hidden;
  box-shadow: 0 1.5rem 3rem rgba(15, 23, 42, 0.22);
}
.avc-shell {
  display: flex;
  flex-direction: column;
  background: #f7fafc;
}
.avc-hero {
  padding: 1.5rem;
  background: linear-gradient(180deg, #eef8f7 0%, #edf4fb 60%, #f4f8fa 100%);
  border-bottom: 1px solid rgba(148, 163, 184, 0.18);
}
.avc-kicker {
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #0f766e;
}
.avc-title { font-size: 1.35rem; font-weight: 800; color: #0f172a; }
.avc-subtitle { color: #64748b; font-size: 0.9rem; }
.avc-close { opacity: 0.6; }
.avc-pills { display: flex; flex-wrap: wrap; gap: 0.5rem; margin-top: 1rem; }
.avc-pill {
  display: inline-flex;
  align-items: center;
  padding: 0.4rem 0.75rem;
  border-radius: 999px;
  font-size: 0.76rem;
  font-weight: 700;
  border: 1px solid rgba(100, 116, 139, 0.18);
  background: rgba(255, 255, 255, 0.9);
  color: #334155;
}
.avc-pill--count { background: rgba(14, 165, 233, 0.12); color: #0369a1; border-color: rgba(14, 165, 233, 0.18); }
.avc-pill--pending { background: rgba(239, 68, 68, 0.12); color: #b91c1c; border-color: rgba(239, 68, 68, 0.22); }
.avc-pill--ok { background: rgba(16, 185, 129, 0.14); color: #047857; border-color: rgba(16, 185, 129, 0.22); }

.avc-body { padding: 1.25rem 1.5rem; max-height: 60vh; overflow-y: auto; }
.avc-list { display: flex; flex-direction: column; gap: 0.75rem; }

.avc-item {
  display: flex;
  gap: 0.85rem;
  padding: 0.9rem 1rem;
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-left-width: 4px;
  border-radius: 0.85rem;
  background: #fff;
  box-shadow: 0 0.35rem 0.9rem rgba(15, 23, 42, 0.04);
}
.avc-item__icon {
  flex: 0 0 auto;
  width: 2.1rem;
  height: 2.1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.65rem;
  font-size: 1.15rem;
}
.avc-item__content { min-width: 0; flex: 1 1 auto; }
.avc-item__head { display: flex; flex-wrap: wrap; gap: 0.4rem; margin-bottom: 0.35rem; }
.avc-item__title { font-weight: 700; color: #0f172a; }
.avc-item__msg { color: #334155; font-size: 0.95rem; white-space: pre-line; }
.avc-tag {
  display: inline-flex;
  align-items: center;
  padding: 0.14rem 0.55rem;
  border-radius: 999px;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  border: 1px solid transparent;
}
.avc-tag--req { background: rgba(239, 68, 68, 0.12); color: #b91c1c; border-color: rgba(239, 68, 68, 0.22); }

/* Cores por tipo */
.avc-item--info { border-left-color: #3b82f6; background: rgba(59, 130, 246, 0.06); }
.avc-item--info .avc-item__icon { background: rgba(59, 130, 246, 0.14); color: #1d4ed8; }
.avc-item--info .avc-tag { background: rgba(59, 130, 246, 0.14); color: #1d4ed8; }
.avc-item--warning { border-left-color: #f59e0b; background: rgba(245, 158, 11, 0.08); }
.avc-item--warning .avc-item__icon { background: rgba(245, 158, 11, 0.16); color: #b45309; }
.avc-item--warning .avc-tag { background: rgba(245, 158, 11, 0.16); color: #b45309; }
.avc-item--danger { border-left-color: #ef4444; background: rgba(239, 68, 68, 0.06); }
.avc-item--danger .avc-item__icon { background: rgba(239, 68, 68, 0.14); color: #b91c1c; }
.avc-item--danger .avc-tag { background: rgba(239, 68, 68, 0.14); color: #b91c1c; }

.avc-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.6rem;
  padding: 0.9rem 1.5rem;
  background: rgba(255, 255, 255, 0.96);
  border-top: 1px solid rgba(148, 163, 184, 0.18);
}

/* Inline (Passo 2) */
.ticket-wizard .avc-inline {
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 1rem;
  padding: 1rem 1.1rem;
  background: linear-gradient(180deg, #f8fbff 0%, #f4f8fb 100%);
  box-shadow: 0 0.5rem 1.2rem rgba(15, 23, 42, 0.05);
}
.ticket-wizard .avc-inline__head {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.85rem;
  font-weight: 800;
  color: #0f172a;
}
.ticket-wizard .avc-inline__head > i { color: #0f766e; font-size: 1.15rem; }
.ticket-wizard .avc-inline__title { font-size: 0.95rem; }
.ticket-wizard .avc-inline__badge {
  margin-left: auto;
  padding: 0.24rem 0.65rem;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 800;
  background: rgba(239, 68, 68, 0.12);
  color: #b91c1c;
  border: 1px solid rgba(239, 68, 68, 0.22);
}

/* Dark mode */
[data-bs-theme="dark"] .avc-shell { background: #0f172a; }
[data-bs-theme="dark"] .avc-hero {
  background: linear-gradient(180deg, #1a2535 0%, #182230 60%, #18212b 100%);
  border-bottom-color: rgba(148, 163, 184, 0.16);
}
[data-bs-theme="dark"] .avc-title { color: #e2e8f0; }
[data-bs-theme="dark"] .avc-kicker,
[data-bs-theme="dark"] .ticket-wizard .avc-inline__head > i { color: #5eead4; }
[data-bs-theme="dark"] .avc-pill { background: rgba(30, 41, 59, 0.7); color: #cbd5e1; }
[data-bs-theme="dark"] .avc-item {
  background: rgba(30, 41, 59, 0.55);
  border-color: rgba(148, 163, 184, 0.16);
}
[data-bs-theme="dark"] .avc-item--info { background: rgba(59, 130, 246, 0.14); }
[data-bs-theme="dark"] .avc-item--warning { background: rgba(245, 158, 11, 0.14); }
[data-bs-theme="dark"] .avc-item--danger { background: rgba(239, 68, 68, 0.14); }
[data-bs-theme="dark"] .avc-item__title { color: #e2e8f0; }
[data-bs-theme="dark"] .avc-item__msg { color: #cbd5e1; }
[data-bs-theme="dark"] .avc-footer {
  background: rgba(24, 33, 43, 0.96);
  border-top-color: rgba(148, 163, 184, 0.16);
}
[data-bs-theme="dark"] .ticket-wizard .avc-inline {
  background: linear-gradient(180deg, rgba(26, 37, 53, 0.6) 0%, rgba(24, 34, 48, 0.5) 100%);
  border-color: rgba(148, 163, 184, 0.16);
}
[data-bs-theme="dark"] .ticket-wizard .avc-inline__head { color: #e2e8f0; }
</style>

<script>
import animationData from "@/components/widgets/lupuorrc.json";
import Lottie from "@/components/widgets/lottie.vue";
import Multiselect from 'vue-multiselect';
//import CKEditor from "@ckeditor/ckeditor5-vue";
import CustomEditor from "@/ckeditor.js";
import { aviso, erro, removerTagsHtml } from "@/helpers/mirai/custom";
import { classificarLocalidade } from "@/helpers/mirai/localidade";
import axios from "axios";
import FotosChamado from "@/views/mirai/dashboard/components/FotosChamado.vue";

const PERGUNTA_SECRETARIA = "Em qual secretaria você está lotado?";
const PERGUNTA_SETOR = "Em qual setor você está lotado?";

const obterUsuarioStorage = () => {
  try {
    const raw = localStorage.getItem("userdata");
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch (error) {
    console.warn("Falha ao ler usuário do storage:", error?.message || error);
    return {};
  }
};

export default {
  name: "novoChamado",
  props: {
    historicoChamados: {
      type: Array,
      default: () => [],
    },
    modalAberto: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      user: obterUsuarioStorage(),
      sendData: {},
      editor: CustomEditor,
      config: {
        language: 'pt-br'
      },
      editorData: "",
      descLen: 0,
      perguntas: {},
      documento: false,

      progressbarvalue: 0,
      activeTab: 1,

      // Arrow Nav Steps
      activeTabArrow: 2,

      // Vertical nav Steps
      activeTabVerti: 2,
      defaultOptions: { animationData: animationData },
      isSubmitting: false,
      isLoadingCategorias: false,
      searchTimeoutCategoria: null,
      // Ids das localidades de atendimento interno cadastradas no CSTIC.
      // Só valem para localidade sem o custom field `atendimento` no NetBox.
      localidadesInternas: [],
      localidadeSugeridaTimer: null,
      buscaCategoriaRequestSeq: 0,
      buscaLocalidadeTermo: "",
      timeoutRecomendacaoCategoriaMs: 2500,
      categoriasSugestoes: [],
      avisosChamado: [],
      avisoChamadoErro: "",
      carregandoAvisosChamado: false,
      confirmacoesAvisosChamado: {},
      modalAvisosChamadoAberto: false,
      timeoutAvisosChamado: null,
      avisosChamadoRequestSeq: 0,
      assinaturaAvisosModalExibida: "",
      criterioCategoriaPadrao: {
        preferirEscape: true,
        termosPrioritarios: [
          "outros problemas relacionados",
          "outros assuntos relacionados",
          "outros",
        ],
      },
      criterioLocalidadePadrao: {
        idPreferencial: Number(process.env.VUE_APP_LOCALIDADE_PADRAO_ID || 0),
        termosPrioritarios: [
          "pmc - sede",
          "sede",
        ],
      },
      resumoFinalChamado: null,
      localidadeSugeridaId: null,
      localidadeSugeridaOrigem: null,
      localidadeSugeridaJanela: 10,
      localidadeSugeridaAplicada: false,
      localidadeSugeridaTentativas: 0,
      historicoChamadosRecentes: [],
      localidadeSelecionadaManual: false,
      detalhamentoCategoriaEscape: "",
      isAvaliandoCategoriaEscape: false,
      avaliacaoCategoriaEscape: {
        mensagem: "",
        variant: "secondary",
      },
      // Perguntas "secretaria"/"setor" amarradas ao cadastro de Unidades
      // (sincronizado do SEI) — mesmo padrão já usado em Inventário de
      // Sistemas (FormAplicacao.vue): secretaria = unidades nível 1 com
      // órgão reconhecido; setor = sub-unidades da secretaria escolhida,
      // em ordem hierárquica.
      unidadesSecretarias: [],
      unidadesSetoresPorSecretaria: [],
      carregandoSetoresUnidade: false,
    };
  },
  components: {
    lottie: Lottie,
    Multiselect,
    FotosChamado,
    //ckeditor: CKEditor.component
  },
  computed: {
    // Classificação da localidade escolhida: custom field `atendimento` do
    // NetBox e, se vazio, a lista cadastrada pelo CSTIC. O portal só marca o
    // chamado como externo — quem agenda a visita é a equipe, no módulo Rotas.
    classificacaoLocalidade() {
      return classificarLocalidade(this.sendData?.localidade, this.localidadesInternas);
    },
    atendimentoExterno() {
      return this.classificacaoLocalidade === "externa";
    },
    perguntaSetorTexto() {
      return PERGUNTA_SETOR;
    },
    secretariaEscolhidaTexto() {
      return this.perguntas?.[PERGUNTA_SECRETARIA] || "";
    },
    autoriza() {
      const lista = this.perguntasRenderizadas;
      if (lista.length === 0) return false;

      return lista.every((perguntaItem, index) => {
        const texto = this.formatarRespostaPergunta(
          this.perguntas?.[perguntaItem.pergunta],
          perguntaItem.tipo,
        );
        const tamanho = texto.length;
        if (index === 0) {
          return tamanho >= 14;
        }

        if (this.isPerguntaOpcional(index)) {
          return true;
        }

        return tamanho > 0;
      });
    },
    stepOneReady() {
      return this.stepOneAnsweredCount >= this.stepOneRequiredCount;
    },
    categoriaSelecionadaId() {
      const id = Number(this.sendData?.categoria?.id || 0);
      return Number.isFinite(id) && id > 0 ? id : null;
    },
    localidadeSelecionadaId() {
      const id = Number(this.sendData?.localidade?.id || 0);
      return Number.isFinite(id) && id > 0 ? id : null;
    },
    avisosPasso1() {
      return (Array.isArray(this.avisosChamado) ? this.avisosChamado : [])
        .filter((item) => ["passo1", "ambos"].includes(this.normalizarPassoAviso(item?.passo_exibicao)));
    },
    avisosPasso2() {
      return (Array.isArray(this.avisosChamado) ? this.avisosChamado : [])
        .filter((item) => ["passo2", "ambos"].includes(this.normalizarPassoAviso(item?.passo_exibicao)));
    },
    avisosBloqueantesChamado() {
      return this.avisosPasso1
        .filter((item) => this.toBool(item?.bloqueia_continuar, false));
    },
    avisosPendentesConfirmacaoChamado() {
      return this.avisosBloqueantesChamado
        .filter((item) => !this.isAvisoChamadoConfirmado(item?.id))
        .length;
    },
    avisosPasso2Bloqueantes() {
      return this.avisosPasso2
        .filter((item) => this.toBool(item?.bloqueia_continuar, false));
    },
    avisosPasso2Pendentes() {
      return this.avisosPasso2Bloqueantes
        .filter((item) => !this.isAvisoChamadoConfirmado(item?.id))
        .length;
    },
    stepOneRequiredCount() {
      return this.isCategoriaEscapeSelecionada ? 3 : 2;
    },
    stepOneAnsweredCount() {
      let count = 0;
      if (this.sendData?.categoria) count += 1;
      if (this.sendData?.localidade) count += 1;
      if (this.isCategoriaEscapeSelecionada && this.detalhamentoCategoriaEscapeTrimmed.length > 0) count += 1;
      return count;
    },
    stepOneMissingCount() {
      return Math.max(this.stepOneRequiredCount - this.stepOneAnsweredCount, 0);
    },
    stepOneProgress() {
      if (this.stepOneRequiredCount <= 0) return 0;
      return Math.round((this.stepOneAnsweredCount / this.stepOneRequiredCount) * 100);
    },
    categoriaDestaqueAtivo() {
      return Boolean(!this.sendData?.categoria && this.sendData?.localidade);
    },
    isCategoriaEscapeSelecionada() {
      return this.toBool(this.sendData?.categoria?.is_escape, false);
    },
    /**
     * Categoria de direcionamento fixo: ignora o núcleo técnico mapeado na
     * localidade e usa a atribuição definida na própria categoria. É para
     * assunto atendido sempre pela mesma equipe, em qualquer localidade.
     */
    categoriaComBypass() {
      return this.toBool(this.sendData?.categoria?.bypass_direcionamento, false);
    },
    /**
     * Atribuição vinda da categoria. O template já é copiado para o `sendData`
     * ao escolher a categoria, mas ler direto dele é a fonte confiável quando
     * a cópia não trouxe o campo.
     */
    atribuicoesDaCategoria() {
      const doTemplate = this.sendData?.categoria?.template?.TarefaAtribuido;
      if (Array.isArray(doTemplate) && doTemplate.length > 0) return doTemplate;
      return Array.isArray(this.sendData?.TarefaAtribuido) ? this.sendData.TarefaAtribuido : [];
    },
    detalhamentoCategoriaEscapeTrimmed() {
      return String(this.detalhamentoCategoriaEscape || "").trim();
    },
    detalhamentoCategoriaEscapePalavras() {
      const texto = this.detalhamentoCategoriaEscapeTrimmed;
      if (!texto) return 0;
      return texto.split(/\s+/).filter((item) => item.length > 0).length;
    },
    detalhamentoCategoriaEscapeSuficiente() {
      return this.detalhamentoCategoriaEscapeTrimmed.length >= 80
        && this.detalhamentoCategoriaEscapePalavras >= 12;
    },
    perguntasRenderizadas() {
      const lista = Array.isArray(this.sendData?.perguntas) ? this.sendData.perguntas : [];
      return lista
        .map((item) => this.normalizarPergunta(item))
        .filter((item) => item.pergunta.length > 0);
    },
    questionRequiredCount() {
      const lista = this.perguntasRenderizadas;
      if (lista.length === 0) return 0;

      return lista.reduce((acc, _, index) => {
        return acc + (this.isPerguntaOpcional(index) ? 0 : 1);
      }, 0);
    },
    questionAnsweredCount() {
      const lista = this.perguntasRenderizadas;
      if (lista.length === 0) return 0;

      let count = 0;
      lista.forEach((perguntaItem, index) => {
        if (this.isPerguntaOpcional(index)) return;

        const resposta = this.perguntas?.[perguntaItem.pergunta];
        const texto = this.formatarRespostaPergunta(resposta, perguntaItem.tipo);
        if (index === 0) {
          if (texto.length >= 14) count += 1;
          return;
        }

        if (texto.length > 0) count += 1;
      });

      return count;
    },
    faltamPerguntasObrigatorias() {
      return Math.max(this.questionRequiredCount - this.questionAnsweredCount, 0);
    },
    requiredProgress() {
      if (this.questionRequiredCount <= 0) return 0;
      return Math.round((this.questionAnsweredCount / this.questionRequiredCount) * 100);
    },
    catcom() {
      if (!this.$categorias || !this.$categorias.data) return [];

      return this.$categorias.data
        .filter((cat) => String(cat?.amigavel || "").trim().length > 0)
        .map(cat => {
          const titulo = String(cat?.amigavel || "").trim();
          return {
            ...cat,
            amigavel: titulo,
          };
        })
        .sort((a, b) => {
          const aTitulo = String(a.amigavel || "");
          const bTitulo = String(b.amigavel || "");
          return aTitulo.localeCompare(bTitulo);
        });
    },
    localidadesDisponiveis() {
      const lista = Array.isArray(this.$localidades?.data) ? this.$localidades.data : [];
      return lista.filter((localidade) => {
        const status = String(localidade?.status?.value || localidade?.status || "").toLowerCase();
        return status === "active" || status === "retired";
      });
    },
    localidadeOpcoesFiltradas() {
      const lista = this.localidadesDisponiveis;
      const termo = this.normalizarTextoBusca(this.buscaLocalidadeTermo);
      if (!termo) return lista;

      const tokens = termo.split(/\s+/).filter((item) => item.length > 0);
      if (tokens.length === 0) return lista;

      const ranqueadas = [];
      lista.forEach((localidade) => {
        const nome = this.normalizarTextoBusca(localidade?.name);
        const endereco = this.normalizarTextoBusca(localidade?.physical_address);
        if (!nome && !endereco) return;

        let score = 0;
        let encontrou = false;
        tokens.forEach((token) => {
          const nomePartes = nome.split(/\s+/).filter((item) => item.length > 0);
          const enderecoPartes = endereco.split(/\s+/).filter((item) => item.length > 0);

          if (nome.startsWith(token)) {
            score += 120;
            encontrou = true;
          } else if (nomePartes.some((parte) => parte.startsWith(token))) {
            score += 90;
            encontrou = true;
          } else if (nome.includes(token)) {
            score += 70;
            encontrou = true;
          }

          if (endereco.startsWith(token)) {
            score += 60;
            encontrou = true;
          } else if (enderecoPartes.some((parte) => parte.startsWith(token))) {
            score += 45;
            encontrou = true;
          } else if (endereco.includes(token)) {
            score += 30;
            encontrou = true;
          }
        });

        if (!encontrou) return;

        const tokenNoNome = tokens.some((token) => nome.includes(token));
        const tokenNoEndereco = tokens.some((token) => endereco.includes(token));
        if (tokenNoNome && tokenNoEndereco) {
          score += 25;
        }

        ranqueadas.push({
          localidade,
          score,
          nomeOriginal: String(localidade?.name || ""),
        });
      });

      return ranqueadas
        .sort((a, b) => {
          if (b.score !== a.score) return b.score - a.score;
          return a.nomeOriginal.localeCompare(b.nomeOriginal, "pt-BR");
        })
        .map((item) => item.localidade);
    },
    possuiHistoricoChamados() {
      const historicoRecente = Array.isArray(this.historicoChamadosRecentes)
        ? this.historicoChamadosRecentes.length
        : 0;
      if (historicoRecente > 0) return true;
      const historicoProp = Array.isArray(this.historicoChamados)
        ? this.historicoChamados.length
        : 0;
      return historicoProp > 0;
    },
    mostrarAvisoLocalidadeSugerida() {
      const localidadeSelecionadaId = Number(this.sendData?.localidade?.id || 0);
      const localidadeSugeridaId = Number(this.localidadeSugeridaId || 0);
      if (!this.possuiHistoricoChamados) return false;
      if (!this.localidadeSugeridaAplicada) return false;
      if (!Number.isFinite(localidadeSelecionadaId) || localidadeSelecionadaId <= 0) return false;
      if (!Number.isFinite(localidadeSugeridaId) || localidadeSugeridaId <= 0) return false;
      return localidadeSelecionadaId === localidadeSugeridaId;
    },
  },
  methods: {
    normalizarIds(ids) {
      if (!ids) return [];
      if (Array.isArray(ids)) {
        return ids
          .map((item) => {
            if (item && typeof item === "object") {
              if (item.id !== undefined) return Number(item.id);
              if (item.setor !== undefined) return Number(item.setor);
              return Number.NaN;
            }
            return Number(item);
          })
          .filter((item) => Number.isFinite(item) && item > 0);
      }
      if (typeof ids === "string") {
        const txt = ids.trim();
        if (!txt) return [];
        try {
          const parsed = JSON.parse(txt);
          if (Array.isArray(parsed)) {
            return parsed
              .map((item) => Number(item))
              .filter((item) => Number.isFinite(item) && item > 0);
          }
        } catch (_error) {
          // noop
        }
        return txt
          .split(",")
          .map((item) => Number(item.trim()))
          .filter((item) => Number.isFinite(item) && item > 0);
      }
      const numero = Number(ids);
      return Number.isFinite(numero) && numero > 0 ? [numero] : [];
    },
    obterSetorIdsUsuario() {
      return this.normalizarIds(this.user?.setores);
    },
    normalizarTextoBusca(texto) {
      return String(texto || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .trim();
    },
    getAvisoChamadoVariant(tipo = "") {
      const normalized = String(tipo || "").trim().toLowerCase();
      if (normalized === "critico") return "danger";
      if (normalized === "alerta") return "warning";
      return "info";
    },
    getAvisoChamadoIcon(tipo = "") {
      const normalized = String(tipo || "").trim().toLowerCase();
      if (normalized === "critico") return "ri-error-warning-line";
      if (normalized === "alerta") return "ri-alert-line";
      return "ri-information-line";
    },
    getAvisoChamadoTipoLabel(tipo = "") {
      const normalized = String(tipo || "").trim().toLowerCase();
      if (normalized === "critico") return "Crítico";
      if (normalized === "alerta") return "Alerta";
      return "Informativo";
    },
    normalizarPassoAviso(valor) {
      const passo = String(valor || "").trim().toLowerCase();
      if (["passo1", "passo2", "ambos"].includes(passo)) return passo;
      if (passo === "1") return "passo1";
      if (passo === "2") return "passo2";
      return "ambos";
    },
    rolarAteAvisosPasso2() {
      this.$nextTick(() => {
        const alvo = document.getElementById("avisos-passo2-cau");
        if (alvo && typeof alvo.scrollIntoView === "function") {
          alvo.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      });
    },
    gerarAssinaturaAvisosChamado(lista = []) {
      const categoriaId = Number(this.categoriaSelecionadaId || 0);
      const localidadeId = Number(this.localidadeSelecionadaId || 0);
      const ids = (Array.isArray(lista) ? lista : [])
        .map((item) => Number(item?.id || 0))
        .filter((id) => Number.isFinite(id) && id > 0)
        .sort((a, b) => a - b)
        .join(",");
      return `${categoriaId}:${localidadeId}:${ids}`;
    },
    isAvisoChamadoConfirmado(avisoId) {
      const id = Number(avisoId || 0);
      if (!Number.isFinite(id) || id <= 0) return false;
      return this.toBool(this.confirmacoesAvisosChamado?.[id], false);
    },
    alternarConfirmacaoAvisoChamado(avisoId, confirmado = false) {
      const id = Number(avisoId || 0);
      if (!Number.isFinite(id) || id <= 0) return;
      this.confirmacoesAvisosChamado = {
        ...(this.confirmacoesAvisosChamado || {}),
        [id]: Boolean(confirmado),
      };
    },
    sincronizarConfirmacoesAvisoChamado(lista = []) {
      const atuais = this.confirmacoesAvisosChamado && typeof this.confirmacoesAvisosChamado === "object"
        ? this.confirmacoesAvisosChamado
        : {};
      const proximas = {};
      (Array.isArray(lista) ? lista : []).forEach((item) => {
        const id = Number(item?.id || 0);
        if (!Number.isFinite(id) || id <= 0) return;
        proximas[id] = this.toBool(atuais[id], false);
      });
      this.confirmacoesAvisosChamado = proximas;
    },
    limparAvisosChamado() {
      this.avisosChamado = [];
      this.avisoChamadoErro = "";
      this.confirmacoesAvisosChamado = {};
      this.modalAvisosChamadoAberto = false;
      this.assinaturaAvisosModalExibida = "";
    },
    agendarCarregamentoAvisosChamado() {
      if (!this.modalAberto) return;
      clearTimeout(this.timeoutAvisosChamado);
      this.timeoutAvisosChamado = setTimeout(() => {
        this.timeoutAvisosChamado = null;
        this.carregarAvisosChamado();
      }, 250);
    },
    async carregarAvisosChamado() {
      if (!this.modalAberto) {
        this.carregandoAvisosChamado = false;
        return;
      }

      const categoriaId = this.categoriaSelecionadaId;
      const localidadeId = this.localidadeSelecionadaId;
      const requestSeq = this.avisosChamadoRequestSeq + 1;
      this.avisosChamadoRequestSeq = requestSeq;

      if (!categoriaId && !localidadeId) {
        this.limparAvisosChamado();
        this.carregandoAvisosChamado = false;
        return;
      }

      this.carregandoAvisosChamado = true;
      this.avisoChamadoErro = "";
      try {
        const params = {};
        if (categoriaId) params.categoriaId = categoriaId;
        if (localidadeId) params.localidadeId = localidadeId;

        const response = await axios.get("/aviso/chamado", { params });
        if (requestSeq !== this.avisosChamadoRequestSeq) return;

        const lista = Array.isArray(response?.data?.avisos) ? response.data.avisos : [];
        this.avisosChamado = lista
          .map((item) => ({
            ...item,
            id: Number(item?.id || 0),
            titulo: String(item?.titulo || "").trim(),
            mensagem: String(item?.mensagem || "").trim(),
          }))
          .filter((item) => Number.isFinite(item.id) && item.id > 0 && item.mensagem.length > 0);
        this.sincronizarConfirmacoesAvisoChamado(this.avisosChamado);

        if (this.avisosPasso1.length > 0 && this.activeTab === 1) {
          const assinaturaAtual = this.gerarAssinaturaAvisosChamado(this.avisosPasso1);
          if (assinaturaAtual !== this.assinaturaAvisosModalExibida) {
            this.assinaturaAvisosModalExibida = assinaturaAtual;
            this.modalAvisosChamadoAberto = true;
          }
        } else {
          this.assinaturaAvisosModalExibida = "";
          this.modalAvisosChamadoAberto = false;
        }
      } catch (error) {
        if (requestSeq !== this.avisosChamadoRequestSeq) return;
        console.error("Não foi possível carregar os avisos do chamado:", error?.response?.data || error);
        this.avisosChamado = [];
        this.confirmacoesAvisosChamado = {};
        this.avisoChamadoErro = "Não foi possível carregar os avisos para a seleção atual.";
      } finally {
        if (requestSeq === this.avisosChamadoRequestSeq) {
          this.carregandoAvisosChamado = false;
        }
      }
    },
    async onContinuarPrimeiraEtapa() {
      if (!this.stepOneReady || this.isAvaliandoCategoriaEscape || this.carregandoAvisosChamado) return;

      if (this.avisosPasso1.length > 0) {
        this.modalAvisosChamadoAberto = true;
        return;
      }

      await this.avancarPrimeiraEtapa();
    },
    async confirmarAvisosEContinuar() {
      if (this.carregandoAvisosChamado || this.isAvaliandoCategoriaEscape) return;

      if (this.avisosPendentesConfirmacaoChamado > 0) {
        aviso({ text: "Para continuar, marque a confirmação dos avisos obrigatórios." });
        return;
      }

      this.modalAvisosChamadoAberto = false;
      await this.avancarPrimeiraEtapa();
    },
    normalizarCategoriaSugestao(categoria) {
      if (!categoria || typeof categoria !== "object") return null;
      const id = Number(categoria?.id || 0);
      const amigavel = String(categoria?.amigavel || "").trim();
      if (!Number.isFinite(id) || id <= 0 || !amigavel) return null;
      return this.completarCategoriaComCadastro(categoria, { id, amigavel });
    },
    /**
     * A sugestão devolvida por `/categoria/sugerir` é um recorte da categoria.
     * Campos que decidem a fila do chamado (direcionamento fixo e template)
     * vêm da listagem completa quando o recorte não os trouxe — sem isso o
     * bypass nunca se aplica no portal.
     */
    completarCategoriaComCadastro(categoria, { id, amigavel } = {}) {
      const idAlvo = Number(id ?? categoria?.id ?? 0);
      const cadastro = (Array.isArray(this.$categorias?.data) ? this.$categorias.data : [])
        .find((item) => Number(item?.id || 0) === idAlvo) || null;

      const completa = cadastro ? { ...cadastro } : {};
      Object.keys(categoria).forEach((chave) => {
        const valor = categoria[chave];
        if (valor === undefined || valor === null) return;
        completa[chave] = valor;
      });

      completa.id = idAlvo;
      completa.amigavel = String(amigavel ?? completa.amigavel ?? "").trim();
      return completa;
    },
    deduplicarCategoriasPorId(lista = []) {
      const mapa = new Map();
      lista.forEach((item) => {
        const id = Number(item?.id || 0);
        if (!Number.isFinite(id) || id <= 0) return;
        if (!mapa.has(id)) mapa.set(id, item);
      });
      return Array.from(mapa.values());
    },
    obterCategoriasEscapeDisponiveis() {
      const base = Array.isArray(this.catcom) ? this.catcom : [];
      const escapes = base
        .filter((item) => this.toBool(item?.is_escape, false))
        .map((item) => this.normalizarCategoriaSugestao(item))
        .filter((item) => item !== null);
      return this.deduplicarCategoriasPorId(escapes);
    },
    montarListaSugestoesCategoria(listaBase = [], { limiteNormais = 5 } = {}) {
      const lista = this.deduplicarCategoriasPorId(
        (Array.isArray(listaBase) ? listaBase : [])
          .map((item) => this.normalizarCategoriaSugestao(item))
          .filter((item) => item !== null),
      );

      const normais = [];
      const escapesApi = [];
      lista.forEach((item) => {
        if (this.toBool(item?.is_escape, false)) {
          escapesApi.push(item);
        } else {
          normais.push(item);
        }
      });

      const limite = Number.isFinite(Number(limiteNormais)) && Number(limiteNormais) > 0
        ? Number(limiteNormais)
        : 5;
      const normaisLimitados = normais.slice(0, limite);

      const escapesGlobais = this.obterCategoriasEscapeDisponiveis();
      const escapesFinais = this.deduplicarCategoriasPorId([
        ...escapesApi,
        ...escapesGlobais,
      ]);

      return [
        ...normaisLimitados,
        ...escapesFinais,
      ];
    },
    ranquearCategoriasLocaisPorTermo(query = "") {
      const termo = this.normalizarTextoBusca(query);
      if (!termo) return [];

      const tokens = termo.split(/\s+/).filter((item) => item.length > 0);
      if (tokens.length === 0) return [];

      const base = Array.isArray(this.catcom) ? this.catcom : [];
      return base
        .map((categoria) => {
          const normalizada = this.normalizarCategoriaSugestao(categoria);
          if (!normalizada) return null;

          const texto = this.normalizarTextoBusca(normalizada.amigavel);
          if (!texto) return null;

          let score = 0;
          let encontrou = false;
          const partes = texto.split(/\s+/).filter((item) => item.length > 0);

          tokens.forEach((token) => {
            if (texto.startsWith(token)) {
              score += 120;
              encontrou = true;
            } else if (partes.some((parte) => parte.startsWith(token))) {
              score += 90;
              encontrou = true;
            } else if (texto.includes(token)) {
              score += 65;
              encontrou = true;
            }
          });

          if (!encontrou) return null;
          return {
            ...normalizada,
            __scoreBuscaLocal: score,
          };
        })
        .filter((item) => item !== null)
        .sort((a, b) => Number(b.__scoreBuscaLocal || 0) - Number(a.__scoreBuscaLocal || 0))
        .map((item) => {
          const clone = { ...item };
          delete clone.__scoreBuscaLocal;
          return clone;
        });
    },
    definirAvaliacaoCategoriaEscape(mensagem = "", variant = "secondary") {
      this.avaliacaoCategoriaEscape = {
        mensagem: String(mensagem || "").trim(),
        variant: variant || "secondary",
      };
    },
    limparAvaliacaoCategoriaEscape({ limparTexto = false } = {}) {
      if (limparTexto) {
        this.detalhamentoCategoriaEscape = "";
      }
      this.definirAvaliacaoCategoriaEscape("", "secondary");
    },
    resolverCategoriaPorId(categoriaId, sugestoes = []) {
      const idAlvo = Number(categoriaId || 0);
      if (!Number.isFinite(idAlvo) || idAlvo <= 0) return null;

      const normalizar = (categoria) => {
        if (!categoria) return null;
        const amigavel = String(categoria?.amigavel || "").trim();
        if (!amigavel) return null;
        return this.completarCategoriaComCadastro(categoria, {
          id: Number(categoria.id),
          amigavel,
        });
      };

      const fontes = [
        ...(Array.isArray(sugestoes) ? sugestoes : []),
        ...(Array.isArray(this.categoriasSugestoes) ? this.categoriasSugestoes : []),
        ...(Array.isArray(this.catcom) ? this.catcom : []),
        ...(Array.isArray(this.$categorias?.data) ? this.$categorias.data : []),
      ];

      for (const item of fontes) {
        if (Number(item?.id || 0) !== idAlvo) continue;
        const categoria = normalizar(item);
        if (categoria) return categoria;
      }

      return null;
    },
    resolverCategoriaPorRankingEscape(sugestoes = []) {
      const lista = Array.isArray(sugestoes) ? sugestoes : [];
      if (lista.length === 0) return null;

      const candidatos = lista
        .filter((item) => item && !this.toBool(item?.is_escape, false))
        .map((item) => ({
          ...item,
          scoreNumero: Number(item?.score || 0),
          confiancaTexto: String(item?.confianca || "").toLowerCase(),
        }))
        .sort((a, b) => b.scoreNumero - a.scoreNumero);

      if (candidatos.length === 0) return null;

      const principal = candidatos[0];
      const segundo = candidatos[1] || null;
      const margem = principal.scoreNumero - Number(segundo?.scoreNumero || 0);
      const palavrasTexto = this.normalizarTextoBusca(this.detalhamentoCategoriaEscapeTrimmed)
        .split(/\s+/)
        .filter((item) => item.length > 0);

      const confiancaAlta = principal.confiancaTexto === "alta" || principal.scoreNumero >= 0.75;
      const confiancaMediaComMargem = principal.scoreNumero >= 0.58 && margem >= 0.14 && palavrasTexto.length >= 3;

      if (!confiancaAlta && !confiancaMediaComMargem) {
        return null;
      }

      return this.resolverCategoriaPorId(principal.id, lista);
    },
    async avancarPrimeiraEtapa() {
      if (!this.stepOneReady || this.isAvaliandoCategoriaEscape || this.carregandoAvisosChamado) return;
      this.isAvaliandoCategoriaEscape = true;

      try {
        this.definirAvaliacaoCategoriaEscape("", "secondary");
        if (this.isCategoriaEscapeSelecionada) {
          const detalhamento = this.detalhamentoCategoriaEscapeTrimmed;
          if (detalhamento.length > 0) {
            const setorIds = this.obterSetorIdsUsuario();
            const params = {
              texto: detalhamento,
              limit: 20,
              usarSetores: setorIds.length > 0,
              incluirEscape: false,
              forcarIa: true,
            };
            if (setorIds.length > 0) {
              params.setorIds = setorIds.join(",");
            }

            const response = await axios.get("/categoria/sugerir", {
              params,
              timeout: this.timeoutRecomendacaoCategoriaMs,
            });
            const data = response?.data || {};
            const sugestoesApi = Array.isArray(data?.sugestoes) ? data.sugestoes : [];
            const categoriaRecomendadaId = Number(
              data?.recomendacaoIa?.categoriaId
              || (sugestoesApi.find((item) => item?.recomendado_ia)?.id || 0),
            );

            let categoriaEscolhida = null;
            if (Number.isFinite(categoriaRecomendadaId) && categoriaRecomendadaId > 0) {
              categoriaEscolhida = this.resolverCategoriaPorId(categoriaRecomendadaId, sugestoesApi);
            }

            if (!categoriaEscolhida) {
              categoriaEscolhida = this.resolverCategoriaPorRankingEscape(sugestoesApi);
            }

            if (categoriaEscolhida && !this.toBool(categoriaEscolhida?.is_escape, false)) {
              this.changeCategoria(categoriaEscolhida);
            }
          }
        }
      } catch (error) {
        console.error("Falha ao recomendar categoria de escape:", error?.response?.data || error);
      } finally {
        this.isAvaliandoCategoriaEscape = false;
        this.toggleTab(2, 50);
      }
    },
    popularSugestoesIniciaisCategoria() {
      const totalCategorias = Array.isArray(this.catcom) ? this.catcom.length : 0;
      this.categoriasSugestoes = this.montarListaSugestoesCategoria(this.catcom, {
        limiteNormais: totalCategorias > 0 ? totalCategorias : 5,
      });
    },
    buscaCategorias(termo) {
      clearTimeout(this.searchTimeoutCategoria);

      const query = String(termo || "").trim();
      if (query.length < 2) {
        this.buscaCategoriaRequestSeq += 1;
        this.popularSugestoesIniciaisCategoria();
        this.isLoadingCategorias = false;
        return;
      }

      this.searchTimeoutCategoria = setTimeout(async () => {
        const requestSeq = this.buscaCategoriaRequestSeq + 1;
        this.buscaCategoriaRequestSeq = requestSeq;
        this.isLoadingCategorias = true;
        this.categoriasSugestoes = [];
        try {
          const setorIds = this.obterSetorIdsUsuario();
          const params = {
            texto: query,
            limit: 5,
            usarSetores: setorIds.length > 0,
            incluirEscape: true,
            usarIa: false,
          };
          if (setorIds.length > 0) {
            params.setorIds = setorIds.join(",");
          }

          const response = await axios.get("/categoria/sugerir", { params });
          if (requestSeq !== this.buscaCategoriaRequestSeq) return;
          const sugestoesApi = Array.isArray(response?.data?.sugestoes) ? response.data.sugestoes : [];
          const sugestoesTratadas = this.montarListaSugestoesCategoria(sugestoesApi, { limiteNormais: 5 });
          if (sugestoesTratadas.length > 0) {
            this.categoriasSugestoes = sugestoesTratadas;
            return;
          }

          const fallbackLocal = this.ranquearCategoriasLocaisPorTermo(query);
          this.categoriasSugestoes = this.montarListaSugestoesCategoria(fallbackLocal, { limiteNormais: 5 });
        } catch (error) {
          if (requestSeq !== this.buscaCategoriaRequestSeq) return;
          console.error("Erro ao buscar sugestões de categoria:", error?.response?.data || error);
          const fallbackLocal = this.ranquearCategoriasLocaisPorTermo(query);
          this.categoriasSugestoes = this.montarListaSugestoesCategoria(fallbackLocal, { limiteNormais: 5 });
        } finally {
          if (requestSeq === this.buscaCategoriaRequestSeq) {
            this.isLoadingCategorias = false;
          }
        }
      }, 300);
    },
    obterCategoriaLabel(categoria) {
      return categoria?.amigavel || categoria?.nome || '-';
    },
    labelUnidade(unidade) {
      const desc = unidade?.descricao || unidade?.descricaoOrgao || "";
      return `${unidade?.sigla || ""}${desc ? " - " + desc : ""}`.trim();
    },
    labelUnidadeSetor(unidade) {
      const indent = "  ".repeat(Math.max(0, (unidade?.nivel || 2) - 2));
      const desc = unidade?.descricao || "";
      return `${indent}${unidade?.sigla || ""}${desc ? " - " + desc : ""}`.trim();
    },
    async carregarUnidadesSecretarias() {
      try {
        const { data } = await axios.get("/unidade/orgaos");
        this.unidadesSecretarias = Array.isArray(data) ? data : [];
      } catch (error) {
        this.unidadesSecretarias = [];
        console.error("Falha ao carregar secretarias (unidades):", error?.response?.data || error);
      }
    },
    // Mesma ordenação em árvore (DFS por siglaPai) usada em
    // FormAplicacao.vue, para o "setor" aparecer em ordem hierárquica.
    ordenarUnidadesPorHierarquia(lista, siglaRaiz) {
      const porPai = new Map();
      lista.forEach((item) => {
        const chave = item.siglaPai || siglaRaiz || "__root__";
        if (!porPai.has(chave)) porPai.set(chave, []);
        porPai.get(chave).push(item);
      });
      porPai.forEach((arr) => arr.sort((a, b) => String(a.sigla || "").localeCompare(String(b.sigla || ""))));

      const visitados = new Set();
      const ordenado = [];
      const visitar = (pai) => {
        (porPai.get(pai) || []).forEach((filho) => {
          if (visitados.has(filho.idUnidade)) return;
          visitados.add(filho.idUnidade);
          ordenado.push(filho);
          visitar(filho.sigla);
        });
      };
      visitar(siglaRaiz);
      visitar("__root__");
      lista.forEach((item) => {
        if (!visitados.has(item.idUnidade)) ordenado.push(item);
      });
      return ordenado;
    },
    encontrarPerguntaPorTexto(texto) {
      return (this.sendData.perguntas || []).find(
        (item) => (typeof item === "object" && item ? item.pergunta : item) === texto,
      );
    },
    async atualizarOpcoesSetorUnidade() {
      const perguntaSetor = this.encontrarPerguntaPorTexto(PERGUNTA_SETOR);
      if (!perguntaSetor) return;

      const secretariaEscolhida = this.unidadesSecretarias.find(
        (item) => this.labelUnidade(item) === this.secretariaEscolhidaTexto,
      );
      if (!secretariaEscolhida) {
        perguntaSetor.opcoes = [];
        this.unidadesSetoresPorSecretaria = [];
        return;
      }

      this.carregandoSetoresUnidade = true;
      try {
        const { data } = await axios.get("/aplicacao/unidadesfilhas", {
          params: { idOrgao: secretariaEscolhida.idOrgao },
        });
        const lista = Array.isArray(data) ? data : [];
        const ordenada = this.ordenarUnidadesPorHierarquia(lista, secretariaEscolhida.sigla);
        this.unidadesSetoresPorSecretaria = ordenada;
        // Secretaria sem setores cadastrados: oferece um setor provisório com
        // o mesmo nome da secretaria, para a pessoa não ficar sem opção.
        perguntaSetor.opcoes = ordenada.length > 0
          ? ordenada.map((item) => this.labelUnidadeSetor(item))
          : [this.labelUnidade(secretariaEscolhida)];
      } catch (error) {
        perguntaSetor.opcoes = [];
        this.unidadesSetoresPorSecretaria = [];
        console.error("Falha ao carregar setores da secretaria (unidades):", error?.response?.data || error);
      } finally {
        this.carregandoSetoresUnidade = false;
      }
    },
    normalizarPergunta(item) {
      if (typeof item === 'string') {
        return {
          pergunta: item,
          tipo: 'text',
          opcoes: [],
          mascara: '',
        };
      }

      const pergunta = String(item?.pergunta || item?.label || '').trim();
      const tipo = String(item?.tipo || 'text').trim().toLowerCase();
      const opcoes = Array.isArray(item?.opcoes)
        ? item.opcoes.map((opcao) => String(opcao || '').trim()).filter((opcao) => opcao.length > 0)
        : [];

      return {
        pergunta,
        tipo: ['text', 'textarea', 'select', 'checkbox', 'radio', 'date', 'multiselect', 'singleselect'].includes(tipo) ? tipo : 'text',
        opcoes,
        mascara: String(item?.mascara || item?.mask || '').trim(),
      };
    },
    formatarRespostaPergunta(valor, tipo = 'text') {
      if (Array.isArray(valor)) {
        return valor.map((item) => String(item || '').trim()).filter((item) => item.length > 0).join(', ');
      }
      if (tipo === 'checkbox' || tipo === 'multiselect') {
        return '';
      }
      return String(valor || '').trim();
    },
    inicializarRespostasPerguntas() {
      const perguntasAtualizadas = {};
      this.perguntasRenderizadas.forEach((perguntaItem) => {
        if (!perguntaItem.pergunta) return;
        const valorExistente = this.perguntas?.[perguntaItem.pergunta];
        if (perguntaItem.tipo === 'checkbox' || perguntaItem.tipo === 'multiselect') {
          perguntasAtualizadas[perguntaItem.pergunta] = Array.isArray(valorExistente) ? valorExistente : [];
          return;
        }
        perguntasAtualizadas[perguntaItem.pergunta] = valorExistente !== undefined && valorExistente !== null
          ? valorExistente
          : '';
      });
      this.perguntas = perguntasAtualizadas;
    },
    isPerguntaOpcional(index) {
      const total = this.perguntasRenderizadas.length;
      return total > 0 && index === total - 1;
    },
    montarResumoFinal(payload, responseData) {
      const perguntasLista = this.perguntasRenderizadas;
      const respostas = perguntasLista.map((perguntaItem) => ({
        pergunta: perguntaItem.pergunta,
        resposta: this.formatarRespostaPergunta(this.perguntas?.[perguntaItem.pergunta], perguntaItem.tipo) || '-',
      }));

      const telefoneFormatado = payload?.telefone
        ? String(payload.telefone).replace(/^(\d{2})(\d{4,5})(\d{4})$/, '($1) $2-$3')
        : '-';

      return {
        id: responseData?.id || null,
        solicitante: payload?.solicitante || this.sendData?.solicitante || '-',
        documento: payload?.documento || this.sendData?.documento || '-',
        categoria: this.obterCategoriaLabel(this.sendData?.categoria),
        localidade: this.sendData?.localidade?.name || '-',
        endereco: this.sendData?.localidade?.physical_address || '-',
        telefone: telefoneFormatado,
        respostas,
      };
    },
    resolverCategoriaPadrao() {
      const categorias = Array.isArray(this.catcom) ? this.catcom : [];
      if (categorias.length === 0) return null;

      const termos = Array.isArray(this.criterioCategoriaPadrao?.termosPrioritarios)
        ? this.criterioCategoriaPadrao.termosPrioritarios
            .map((item) => this.normalizarTextoBusca(item))
            .filter((item) => item.length > 0)
        : [];

      const preferirEscape = this.toBool(this.criterioCategoriaPadrao?.preferirEscape, true);
      let base = categorias;
      if (preferirEscape) {
        const escapes = categorias.filter((categoria) => this.toBool(categoria?.is_escape, false));
        if (escapes.length > 0) {
          base = escapes;
        }
      }

      if (termos.length > 0) {
        const porPrefixo = base.find((categoria) => {
          const amigavel = this.normalizarTextoBusca(categoria?.amigavel);
          return termos.some((termo) => amigavel.startsWith(termo));
        });
        if (porPrefixo) return porPrefixo;

        const porContem = base.find((categoria) => {
          const amigavel = this.normalizarTextoBusca(categoria?.amigavel);
          return termos.some((termo) => amigavel.includes(termo));
        });
        if (porContem) return porContem;
      }

      return base[0] || categorias[0] || null;
    },
    selecionarCategoriaPadrao() {
      const categoriaDefault = this.resolverCategoriaPadrao();

      if (categoriaDefault) {
        this.sendData.categoria = categoriaDefault;
        this.changeCategoria(categoriaDefault);

        if (this.$refs.multiselectCategoria) {
          this.$refs.multiselectCategoria.deactivate();
        }
      } else {
        console.warn("Não foi possível determinar a categoria padrão na lista 'catcom'.");
      }
    },
    resolverLocalidadePadrao() {
      const localidades = this.localidadesDisponiveis;
      if (localidades.length === 0) return null;

      const idPreferencial = Number(this.criterioLocalidadePadrao?.idPreferencial || 0);
      if (Number.isFinite(idPreferencial) && idPreferencial > 0) {
        const porId = localidades.find((localidade) => Number(localidade?.id) === idPreferencial);
        if (porId) return porId;
      }

      const termos = Array.isArray(this.criterioLocalidadePadrao?.termosPrioritarios)
        ? this.criterioLocalidadePadrao.termosPrioritarios
            .map((item) => this.normalizarTextoBusca(item))
            .filter((item) => item.length > 0)
        : [];

      if (termos.length > 0) {
        const porTermo = localidades.find((localidade) => {
          const nome = this.normalizarTextoBusca(localidade?.name);
          return termos.some((termo) => nome.includes(termo));
        });
        if (porTermo) return porTermo;
      }

      return localidades[0] || null;
    },
    selecionarLocalidadePadrao() {
      const localidadeDefault = this.resolverLocalidadePadrao();

      if (localidadeDefault) {
        this.sendData.localidade = localidadeDefault;
        this.buscaLocalidadeTermo = "";
        this.localidadeSugeridaAplicada = Number(localidadeDefault.id) === Number(this.localidadeSugeridaId);

        if (this.$refs.multiselectLocalidade) {
          this.$refs.multiselectLocalidade.deactivate();
        }
        this.agendarCarregamentoAvisosChamado();
      } else {
        console.warn("Não foi possível determinar a localidade padrão na lista '$localidades'.");
      }
    },
    onSelectLocalidade(localidade) {
      this.buscaLocalidadeTermo = "";
      this.localidadeSelecionadaManual = true;
      this.localidadeSugeridaAplicada =
        Boolean(this.localidadeSugeridaId) &&
        Number(localidade?.id) === Number(this.localidadeSugeridaId);
      this.agendarCarregamentoAvisosChamado();
    },
    async carregarLocalidadesInternas() {
      try {
        const { data } = await axios.get("/localidade/interna");
        this.localidadesInternas = Array.isArray(data?.localidades) ? data.localidades.map(Number) : [];
      } catch (e) {
        // Sem a lista, sobra a classificação do NetBox (ou nenhuma).
        this.localidadesInternas = [];
      }
    },
    buscaLocalidades(termo) {
      this.buscaLocalidadeTermo = String(termo || "").trim();
    },
    limparBuscaLocalidade() {
      this.buscaLocalidadeTermo = "";
    },
    normalizarLocalidadeId(localidade) {
      if (localidade && typeof localidade === 'object') {
        const idObj = Number(localidade.id || 0);
        return Number.isFinite(idObj) && idObj > 0 ? idObj : null;
      }

      const idNum = Number(localidade || 0);
      return Number.isFinite(idNum) && idNum > 0 ? idNum : null;
    },
    obterLocalidadeSugeridaDoHistorico() {
      const listaBase = Array.isArray(this.historicoChamadosRecentes) && this.historicoChamadosRecentes.length > 0
        ? [...this.historicoChamadosRecentes]
        : (Array.isArray(this.historicoChamados) ? [...this.historicoChamados] : []);
      if (listaBase.length === 0) return null;

      const historicoOrdenado = listaBase
        .sort((a, b) => Number(b?.id || 0) - Number(a?.id || 0))
        .slice(0, 10);

      if (historicoOrdenado.length === 0) return null;

      const rankingMap = new Map();

      historicoOrdenado.forEach((item, index) => {
        const localidadeId = this.normalizarLocalidadeId(item?.localidade);
        if (!localidadeId) return;

        const atual = rankingMap.get(localidadeId) || { localidade: localidadeId, total: 0, recencia: index };
        atual.total += 1;
        if (index < atual.recencia) atual.recencia = index;
        rankingMap.set(localidadeId, atual);
      });

      const ranking = Array.from(rankingMap.values()).sort((a, b) => {
        if (b.total !== a.total) return b.total - a.total;
        return a.recencia - b.recencia;
      });

      if (ranking.length === 0) return null;

      const top = ranking[0];
      return {
        localidadeId: top.localidade,
        origem: top.total > 1 ? "historico_ultimos" : "ultimo_chamado",
        janela: historicoOrdenado.length,
      };
    },
    inicializarLocalidadeSugerida({ force = false } = {}) {
      if (this.localidadeSelecionadaManual) return;
      if (this.sendData.localidade && !force) return;

      const sugestao = this.obterLocalidadeSugeridaDoHistorico();
      if (!sugestao) {
        clearTimeout(this.localidadeSugeridaTimer);
        this.localidadeSugeridaTimer = null;
        this.localidadeSugeridaId = null;
        this.localidadeSugeridaOrigem = null;
        this.localidadeSugeridaJanela = 10;
        this.localidadeSugeridaAplicada = false;
        this.localidadeSugeridaTentativas = 0;
        return;
      }

      if (force) {
        this.sendData.localidade = null;
      }

      this.localidadeSugeridaId = sugestao.localidadeId;
      this.localidadeSugeridaOrigem = sugestao.origem;
      this.localidadeSugeridaJanela = sugestao.janela;
      this.localidadeSugeridaTentativas = 0;
      this.tentarAplicarLocalidadeSugerida();
    },
    async carregarHistoricoChamadosRecentes() {
      try {
        const accountname = String(this.user?.usuario || "").trim();
        if (!accountname) return;

        const where = JSON.stringify({
          finalidade: "chamado",
          accountname,
        });

        const response = await axios.get("/tarefa/data", {
          params: {
            limit: 10,
            where,
          },
        });

        const data = Array.isArray(response?.data?.data) ? response.data.data : [];
        if (!data.length) return;

        this.historicoChamadosRecentes = data;
        this.inicializarLocalidadeSugerida({ force: true });
      } catch (error) {
        console.warn("Não foi possível carregar os 10 últimos chamados para sugestão de localidade:", error?.response?.data || error);
      }
    },
    aplicarLocalidadeSugerida() {
      if (!this.localidadeSugeridaId || this.sendData.localidade) return false;

      const localidades = this.localidadesDisponiveis;
      if (localidades.length === 0) return false;

      const localidade = localidades.find((item) => Number(item.id) === Number(this.localidadeSugeridaId));
      if (!localidade) return false;

      clearTimeout(this.localidadeSugeridaTimer);
      this.localidadeSugeridaTimer = null;
      this.sendData.localidade = localidade;
      this.buscaLocalidadeTermo = "";
      this.localidadeSugeridaAplicada = true;
      return true;
    },
    tentarAplicarLocalidadeSugerida() {
      if (!this.localidadeSugeridaId || this.sendData.localidade) return;
      if (this.aplicarLocalidadeSugerida()) return;

      if (this.localidadeSugeridaTentativas >= 30) return;
      this.localidadeSugeridaTentativas += 1;

      clearTimeout(this.localidadeSugeridaTimer);
      this.localidadeSugeridaTimer = setTimeout(() => {
        this.localidadeSugeridaTimer = null;
        this.tentarAplicarLocalidadeSugerida();
      }, 300);
    },
    async abrirChamado() {
      if (this.isSubmitting) return;

      if (this.avisosPasso2Pendentes > 0) {
        aviso({ text: "Para abrir o chamado, confirme os avisos obrigatórios desta etapa." });
        this.rolarAteAvisosPasso2();
        return;
      }

      this.isSubmitting = true;

      try {
        const payload = {};
        const url = '/tarefa/';

        const fields = ['prioridade', 'documento', 'tarefa', 'solicitante', 'categoria', 'localidade', 'status', 'accountname'];

        for (const field of fields) {
          switch (field) {
            case 'localidade':
              payload[field] = this.sendData[field]?.id || null;
              break;
            case 'categoria':
              payload[field] = this.sendData[field]?.id || null;
              break;
            case 'tarefa':
              payload[field] = removerTagsHtml(this.sendData['categoria']?.amigavel)
                || this.sendData['categoria']?.nome
                || 'Chamado';
              break;
            case 'status':
              payload[field] = 'Nova';
              break;
            default:
              payload[field] = this.sendData[field];
              break;
          }
        }

        const primeiraPergunta = this.perguntasRenderizadas[0]?.pergunta || null;
        if (primeiraPergunta) {
          payload.telefone = String(this.perguntas[primeiraPergunta] || '').replace(/\D/g, '');
        }

        payload.obs = "";
        this.perguntasRenderizadas.forEach((perguntaItem) => {
          const respostaFormatada = this.formatarRespostaPergunta(
            this.perguntas?.[perguntaItem.pergunta],
            perguntaItem.tipo,
          );
          const perguntaTexto = removerTagsHtml(String(perguntaItem?.pergunta || ""));
          const respostaTexto = removerTagsHtml(String(respostaFormatada || ""));
          payload.obs += `<p><b>${perguntaTexto}:</b> ${respostaTexto}</p>`;
        });

        if (this.isCategoriaEscapeSelecionada && this.detalhamentoCategoriaEscapeTrimmed.length > 0) {
          const detalhamentoEscape = removerTagsHtml(this.detalhamentoCategoriaEscapeTrimmed);
          payload.obs = `<p><b>Detalhamento inicial para triagem automática:</b> ${detalhamentoEscape}</p>${payload.obs}`;
        }

        // Regra de fila: usa o grupo do núcleo técnico mapeado na localidade;
        // se não houver, mantém eventuais atribuições já definidas pelo template
        // da categoria. Como piso final, garante uma fila (grupo/setor) caindo
        // no setor de triagem padrão — assim o chamado nunca é aberto sem fila
        // (e o cidadão não é bloqueado).
        //
        // Exceção: categoria marcada com direcionamento fixo (bypass) ignora o
        // núcleo da localidade e vai direto para a atribuição da categoria,
        // em qualquer localidade.
        const atribuicoesAbertura = [];
        const grupoLocalidadeId = this.sendData?.localidade?.custom_fields?.grupo;
        const grupoLocalidade = this.categoriaComBypass || !grupoLocalidadeId
          ? null
          : (this.$grupo?.data || []).find(gp => gp.id === grupoLocalidadeId);
        // Núcleo mapeado que não existe mais na base de grupos não pode engolir
        // a atribuição da categoria: nesse caso a categoria volta a valer.
        const usarAtribuicaoDaCategoria = !grupoLocalidade;

        if (!usarAtribuicaoDaCategoria) {
          atribuicoesAbertura.push({
            tipo: 'grupo',
            atribuido: grupoLocalidade.id,
            atribuidoPara: grupoLocalidade,
          });
        } else if (Array.isArray(this.atribuicoesDaCategoria)) {
          this.atribuicoesDaCategoria.forEach(item => {
            atribuicoesAbertura.push({
              atribuido: item.atribuido,
              tipo: item.tipo,
              atribuidoPara: item.atribuidoPara,
            });
          });
        }
        const possuiFila = atribuicoesAbertura.some(
          item => ['grupo', 'setor'].includes(String(item?.tipo || '').toLowerCase()),
        );
        if (!possuiFila) {
          const setorTriagemId = Number(process.env.VUE_APP_SETOR_TRIAGEM_PADRAO_ID || 4);
          const setor = (this.$setor?.data || []).find(s => s.id === setorTriagemId);
          atribuicoesAbertura.push({
            tipo: 'setor',
            atribuido: setorTriagemId,
            atribuidoPara: setor || { id: setorTriagemId, nome: 'Triagem' },
          });
        }
        payload.TarefaAtribuido = atribuicoesAbertura;

        // O portal só sinaliza que o atendimento é externo (pela classificação
        // da localidade). A data da visita é definida pela equipe no módulo
        // Rotas — por isso não vai `atendimento_externo_em` daqui.
        payload.externo = this.atendimentoExterno;

        const valida = await this.validaForm(payload);
        if (!valida) return;

        const response = await axios.post(url, payload);
        const responseData = response.data.data || response.data;

        if (this.$refs.fotosChamado) {
          await this.$refs.fotosChamado.enviarPendentes(responseData.id, null);
        }

        this.resumoFinalChamado = this.montarResumoFinal(payload, responseData);
        this.toggleTab(3, 100);

        setTimeout(() => {
          const emittedData = { ...payload, all: responseData };
          emittedData.id = responseData.id;
          this.$emit('createEvent', emittedData);
        }, 200);
      } catch (error) {
        erro({ title: error.response?.data?.error || error.message || 'Erro desconhecido ao salvar tarefa.' });
        console.error('Erro na requisição:', error.response?.data || error);
      } finally {
        this.isSubmitting = false;
      }
    },
    async validaForm(payload) {
      if (!payload.categoria) {
        aviso({ text: 'Selecione uma categoria para continuar.' });
        return false;
      }

      if (!payload.solicitante || payload.solicitante.trim().length < 5) {
        aviso({ text: 'Informe o nome do solicitante.' });
        return false;
      }

      if (!payload.documento || payload.documento.trim().length < 5) {
        aviso({ text: 'Informe matrícula ou CPF.' });
        return false;
      }

      if (!payload.localidade) {
        aviso({ text: 'Selecione uma localidade para continuar.' });
        return false;
      }
      if (!Array.isArray(payload.TarefaAtribuido) || payload.TarefaAtribuido.length < 1) {
        aviso({ text: 'É necessário informar pelo menos uma atribuição para abrir o chamado.' });
        return false;
      }

      return true;
    },
    toBool(value, fallback = false) {
      if (typeof value === "boolean") return value;
      if (typeof value === "number") return value !== 0;
      if (typeof value === "string") {
        const normalized = value.trim().toLowerCase();
        if (["1", "true", "sim", "yes", "y"].includes(normalized)) return true;
        if (["0", "false", "nao", "não", "no", "n"].includes(normalized)) return false;
      }
      return fallback;
    },
    clonarValorTemplate(valor) {
      if (Array.isArray(valor) || (valor && typeof valor === "object")) {
        try {
          return JSON.parse(JSON.stringify(valor));
        } catch (_error) {
          if (Array.isArray(valor)) return [...valor];
          return { ...valor };
        }
      }
      return valor;
    },
    limparCamposTemplateCategoria(categoriaAtual = null, proximaCategoria = null) {
      const camposBase = ["obs", "status", "prioridade", "TarefaAtribuido", "TarefaSubtarefa", "titulo", "perguntas"];
      const camposParaLimpar = new Set(camposBase);

      const templateAtual = categoriaAtual?.template && typeof categoriaAtual.template === "object"
        ? categoriaAtual.template
        : {};
      const templateProximo = proximaCategoria?.template && typeof proximaCategoria.template === "object"
        ? proximaCategoria.template
        : {};

      Object.keys(templateAtual).forEach((key) => camposParaLimpar.add(key));
      Object.keys(templateProximo).forEach((key) => camposParaLimpar.add(key));

      camposParaLimpar.forEach((campo) => {
        if (Object.prototype.hasOwnProperty.call(this.sendData, campo)) {
          delete this.sendData[campo];
        }
      });
    },
    changeCategoria(categoria) {
      if (!this.sendData.id) {
        const categoriaAnterior = this.sendData?.categoria || null;
        this.perguntas = {};
        this.limparCamposTemplateCategoria(categoriaAnterior, categoria);

        this.sendData.categoria = categoria;
        this.sendData.perguntas = [
          "Telefone de Contato",
          {
            pergunta: PERGUNTA_SECRETARIA,
            tipo: "singleselect",
            opcoes: this.unidadesSecretarias.map((item) => this.labelUnidade(item)),
          },
          { pergunta: PERGUNTA_SETOR, tipo: "singleselect", opcoes: [] },
        ];

        const templateCategoria = categoria?.template && typeof categoria.template === "object"
          ? categoria.template
          : null;

        if (templateCategoria) {
          Object.keys(templateCategoria).forEach(key => {
            if (key !== 'perguntas') {
              this.sendData[key] = this.clonarValorTemplate(templateCategoria[key]);
            } else {
              const perguntasTemplate = Array.isArray(templateCategoria[key])
                ? templateCategoria[key].map((item) => this.clonarValorTemplate(item))
                : [];
              this.sendData['perguntas'] = [
                ...(this.sendData['perguntas'] || []),
                ...perguntasTemplate
              ];
            }
          });
        }

        this.sendData.perguntas.push('Informações complementares');
        this.inicializarRespostasPerguntas();

        if (this.toBool(categoria?.is_escape, false)) {
          this.limparAvaliacaoCategoriaEscape();
        } else {
          this.limparAvaliacaoCategoriaEscape({ limparTexto: true });
        }
      }
      this.agendarCarregamentoAvisosChamado();
    },
    toggleTab(tab, value) {
      this.activeTab = tab;
      this.progressbarvalue = value;
    }
  },
  mounted() {
    this.sendData.solicitante = String(this.user?.nome || "").trim();
    this.sendData.accountname = String(this.user?.usuario || "").trim();
    const documentoBase = this.user?.matricula || this.user?.descricao || '';
    this.sendData.documento = String(documentoBase).replace(/\D/g, '');

    if (this.sendData.documento.trim().length > 0) {
      this.documento = true;
    }

    this.inicializarLocalidadeSugerida();
    this.carregarHistoricoChamadosRecentes();
    this.popularSugestoesIniciaisCategoria();
    this.carregarUnidadesSecretarias();
    this.carregarLocalidadesInternas();
  },
  watch: {
    historicoChamados() {
      this.inicializarLocalidadeSugerida();
    },
    catcom(newList) {
      if (!Array.isArray(newList) || newList.length === 0) return;
      if (Array.isArray(this.categoriasSugestoes) && this.categoriasSugestoes.length > 0) return;
      this.popularSugestoesIniciaisCategoria();
    },
    // Carrega tarde? Atualiza a pergunta de secretaria já criada com as
    // opções assim que a lista de unidades terminar de chegar.
    unidadesSecretarias(lista) {
      const perguntaSecretaria = this.encontrarPerguntaPorTexto(PERGUNTA_SECRETARIA);
      if (perguntaSecretaria) {
        perguntaSecretaria.opcoes = lista.map((item) => this.labelUnidade(item));
      }
    },
    secretariaEscolhidaTexto(novoValor, valorAnterior) {
      if (novoValor === valorAnterior) return;
      if (Object.prototype.hasOwnProperty.call(this.perguntas || {}, PERGUNTA_SETOR)) {
        this.perguntas[PERGUNTA_SETOR] = "";
      }
      this.atualizarOpcoesSetorUnidade();
    },
  },
  beforeUnmount() {
    clearTimeout(this.searchTimeoutCategoria);
    clearTimeout(this.localidadeSugeridaTimer);
    clearTimeout(this.timeoutAvisosChamado);
  }
};
</script>
